import { addBrowse, browseListContains, filterOpenBrowses, getAllBrowseIds, getAllBrowses, getBrowseById, getBrowseList, getContainingBrowse, getCurrentBrowseName, getInnerBrowse, getOpenBrowses, indexOfOpenBrowse, prependOpenBrowse, removeBrowse, setCurrentOpenBrowse } from "#skyward_browseList";
import { registerErrorDataGatherer, reportException, SkywardException } from "#skyward_error";
import { isIosApp, mobileAccess, processViewPartHtml, processViewPartHtmlSeparately, virtualDir } from "#skyward_global";
import { buildRecommendationModalContent, ButtonDefinition, ButtonDefinitions, ButtonIcon, ButtonText, DEFAULT_CLOSE_BUTTON, elementIsInModalLayer, getLayerFromElement, MenuItemDefinition, ModalDialog, showCriticalDialog, showDialog, showErrorDialog, showMenu, CloseReasons } from "#skyward_modalLayer";
import { checkLoadContent, closePopup, getClosestContentPanel, getImageHtml, hasHorizontalScrollBar, loadContent, notifyDOMLoad, registerBrowseResizeCallback, registerLayoutResizeCallback, registerLoadDOMCallback, removeBrowseResizeCallback, scrollbarHeight, setSkipUnloadCheck, skipUnloadCheck, submitForm, SubmitFormOptions } from "#skyward_window";
import { encodeHtml } from "./skyward.base.extensions";
import { completePerformanceMonitoring } from "./skyward.base.performanceMonitor";
import { DependencySnapshot, getDependencyDataWithoutWaiting, TextBoxData, waitForDependencies, setupDependency } from "./skyward.base.requestDataHash";
import { formatServerDate, isDate, stopwatch } from "./skyward.base.time";
import FieldTree from "./skyward.ui.browse.fieldTree";
import { preInitQuickFilter, Row } from "./skyward.ui.browseFilters";
import { monitorRequest } from "./skyward.ui.browseLoadTimer";
import { save, SeekInfo, setAndGet } from "./skyward.ui.browseSeekInfo";
import { isDirty } from "./skyward.ui.changeTracking";
import { CheckboxBrowse, getData as getCheckboxBrowseData } from "./skyward.ui.checkboxBrowse";
import { getContentMessageArea } from "./skyward.ui.contentMessageArea";
import { getOriginalValue, getScopeContainer, getValue } from "./skyward.ui.controls";
import debounce from "./skyward.ui.debounce";
import { DependentRule } from "./skyward.ui.dependents";
import { getData as getDistinctMultiSelectEELData } from "./skyward.ui.distinctMultiSelectEEL";
import { EditableBrowse, getData as getEditableBrowseData } from "./skyward.ui.editableBrowse";
import { clickEvent, getCallbackStore, getCallbackStoreFacadeCollection, reapplyLoadActionClasses, registerEvents } from "./skyward.ui.events";
import { getSvg } from "./skyward.ui.svg";
import { getSelectedFieldData, type TreeBrowseData } from "./skyward.ui.treebrowse";
import { displayValidationMessages, validDate, validNumber } from "./skyward.ui.validation";
import { addDisableNavigationPromise } from "./skyward.ui.workflow";
import { Browse, BrowseColumnData, BrowseData, BrowsePostData, BrowseScrollEventParams, BrowseStats, BrowseType, DetailsPanelAdditionalEventData, DetailsPanelEventData, DetailsPanelEvents, DetailsPanelType, Dictionary, FormattedFieldProps, JQueryInput, JQueryTouchSwipe, JQueryUIResizable, RelatedBrowse, Stopwatch, TabData } from "./types";
import { Key as SvgKey } from "./types/skyward/svg";

const skyward = window.skyward;

const eventCallbacksInternal =
{
    updateActiveBrowseClasses: getCallbackStore(),
    recordSelectionMade: getCallbackStore()
};

export const eventCallbacks = getCallbackStoreFacadeCollection(eventCallbacksInternal);

const classNames =
{
    addDashboardTile: "js-addDashboardTile",
    allowColumnSort: "js-allowColumnSort",
    anchorText: "anchorText",
    appendMobileBrowseFooter: "js-appendMobileBrowseFooter",
    appendMobileBrowseHeader: "js-appendMobileBrowseHeader",
    bottomBrowsesCollapsed: "bottomBrowsesCollapsed",
    bottomCollapsibleBrowseContainer: "bottomCollapsibleBrowseContainer",
    browse: "browse",
    browseBody: "browseBody",
    browseBodyLoading: "browseBodyLoading",
    browseBodyLockedTotalColumn: "browseBody__lockedTotalColumn",
    browseBodyShadowColumn: "browseBody__shadowColumn",
    browseBodySortablePlaceholder: "browseBodySortablePlaceholder",
    browseBodyTotalButtonsFiller: "browseBody__totalButtonsFiller",
    browseBodyTotalColumn: "browseBody__totalColumn",
    browseBodyTotalColumnHasData: "js-browseBody__totalColumn--hasData",
    browseBodyTotalScrollbarFiller: "js-browseBody__totalScrollbarFiller",
    browseBodyTotalsSection: "browseBody__totalsSection",
    browseBodyTotalsSectionLocked: "browseBody__totalsSection--locked",
    browseBodyTotalsSectionLockedWrapper: "browseBody__totalsSectionLockedWrapper",
    browseBodyTotalsSectionNotReady: "browseBody__totalsSection--notReady",
    browseColumnFilterMenuLaunch: "browseColumnFilterMenuLaunch",
    browseColumnHeaderSort: "browseColumnHeaderSort",
    browseColumnSortSpan: "browseColumnSortSpan",
    browseColumnSuperUser: "browseColumnSuperUser",
    browseColumnIconSpan: "browseColumnIconSpan",
    browseDataCell: "browseDataCell",
    browseExpandCollapseButton: "browseExpandCollapseButton",
    browseHeader: "browseHeader",
    browseHeaderColumn: "browseHeaderColumn",
    browseHeaderDraggable: "browseHeaderDraggable",
    browseHeaderDraggablePlaceholder: "browseHeaderDraggablePlaceholder",
    browseHeaderSpacer: "browseHeaderSpacer",
    browseRow: "browseRow",
    browseRowContent: "browseRowContent",
    browseRowOptions: "browseRowOptions",
    browseSearch: "browseSearch",
    browseSearchBox: "browseSearchBox",
    browseSectionHeader: "browse__sectionHeader",
    button: "button",
    buttonSelectedValueLabel: "buttonSelectedValueLabel",
    buttonParenthesisLabel: "buttonParenthesisLabel",
    cmaErrorMessage: "cmaErrorMessage",
    columnDragging: "columnDragging",
    containerToolbar: "containerToolbar",
    contentArea: "contentArea",
    current: "current",
    currentRecordContentBaseError: "currentRecordContentBaseError",
    customBrowse: "js-custombrowse",
    dataObjectViewer: "dataObjectViewer",
    datepicker: "datepicker",
    dateTimePickerModal: "dateTimePickerModal",
    deleteColumnButton: "js-deleteColumnButton",
    dmsBackingData: "dmsBackingData",
    expandableQuickFilter: "js-expandableQuickFilter",
    expandCollapseBrowsePanel: "js-expandCollapseBrowsePanel",
    hasInitialHeader: "js-hasInitialHeader",
    hideHeaderMobile: "hideHeaderMobile",
    iconContainerDiv: "iconContainerDiv",
    insertColumnButton: "js-insertColumnButton",
    isInDetailsPanel: "js-isInDetailsPanel",
    isSelectionFiltered: "isSelectionFiltered",
    locked: "locked",
    lockedBrowseBody: "lockedBrowseBody",
    lockedBrowseBodyScrollWrapper: "lockedBrowseBody_scrollwrapper",
    lockedBrowseShadow: "lockedBrowseShadow",
    lockedHeader: "lockedHeader",
    lockedHeaderTableRow: "lockedHeaderTableRow",
    mainSelectedBrowse: "mainSelectedBrowse",
    massSelectCell: "js-massSelectCell",
    modalLayerContainer: "modalLayerContainer",
    newWindow: "newWindow",
    noRecordsInBrowse: "noRecordsInBrowse",
    noSearchAvailable: "js-noSearchAvailable",
    pagingButton: "pagingButton",
    pagingButtonDisabled: "pagingButtonDisabled",
    quickFilterActive: "quickFilterActive",
    repeater: "repeater",
    reset: "reset",
    rowAction: "rowAction",
    saveBoolFilterSort: "js-saveBoolFilterSort",
    saveColumnFilterSort: "js-saveColumnFilterSort",
    searchBoxButton: "searchBoxButton",
    sectionHeader: "sectionHeader",
    sectionHeaderText: "sectionHeader__text",
    selectedDetailsRow: "selectedDetailsRow",
    selectedPK: "selectedPK",
    selectRecord: "js-selectRecord",
    settingsIcon: "Settings",
    simulateFocus: "simulateFocus",
    skyVue: "skyVue",
    svg: "svg",
    svgAnchor: "svgAnchor",
    svgBrowseColumnHeader: "svgBrowseColumnHeader",
    tdResizeDiv: "tdResizeDiv",
    topExpandableBrowseContainer: "topExpandableBrowseContainer",
    totalRecordsButton: "totalRecordsButton",
    totalRecordsButtonDisabled: "totalRecordsButtonDisabled",
    translateZ: "translateZ",
    uiDisabled: "ui-disabled",
    unlockedBrowseBody: "unlockedBrowseBody",
    unlockedBrowseTable: "unlockedBrowseTable",
    unlockedHeader: "unlockedHeader",
    unlockedHeaderTableRow: "unlockedHeaderTableRow",
    viewAndFilter: "viewAndFilter",
    workflow: "workflow"
} as const;

const valueNames =
{
    detailsPanelIdentifier: "browse"
} as const;

const mobileBrowseClasses =
{
    mobileBrowseContainer: "mobileBrowseContainer",
    mobileBrowseBody: "mobileBrowseBody",
    hasHeaderShadow: "hasHeaderShadow",
    hasColumnShadow: "hasColumnShadow",
    lockedColumnCell: "lockedColumnCell"
} as const;

export type GatherSearchConditionMessage = MessageEvent<
{
    data: GatherSearchConditionMessageData;
    type: string;
}>;

interface GatherSearchConditionMessageData extends Record<string, unknown>
{
    condition?: string;
    conditionHash?: string;
    browseFilterID?: string | number | null;
    pageModule?: string;
    pageObject?: string;
    dataModule?: string;
    dataObject?: string;
    routeModule?: string;
    routeObject?: string;
    browseName?: string;
    error?: string;
}

export interface PerformCodeEELSearchData extends BrowseData
{
    codeEELSearchText: string;
}

interface BrowseDetailsPanelAdditionalEventData extends DetailsPanelAdditionalEventData
{
    browseName: string;
    primaryKey: number;
    identifier: string;
}

interface DetailsPanelPostData
{
    renderInDetailsPanel: boolean;
    confirmationMessage: string | null | undefined;
    confirmationMessageContainer: string | null | undefined;
    tab?: string;
}

interface RowElementData
{
    rowmodule: string;
    rowobject: string;
    rowscreen: string;
    panelwidth: number;
}

interface ChangeRowsPerPageData extends BrowseData
{
    rowsPerPage?: number;
}

interface SuccessResponse {
    success: boolean;
}

interface ResetViewAndFilterResponse extends SuccessResponse
{
    browseViewId: number;
}

interface GetBrowseSqlResponse extends SuccessResponse
{
    query?: string;
}

interface BrowseTotalsData extends Partial<SuccessResponse>, BrowseData
{
    hasReportingAccess?: boolean;
    totalsPostData?: Record<string, string>;
}

interface BrowseLinkColumnPopupData
{
    "browse.options"?: string;
    "browse.headertext"?: string;
    "browse.button"?: string;
    "browse.cancelButtonText"?: string;
    "browse.cancelButtonIcon"?: SvgKey;
    "browseNameToTriggerResize"?: string;
}

interface BrowseLinkColumnPopupOptions
{
    draggable?: boolean;
}

interface FieldIndex
{
    startingIndex: number;
    endingIndex: number;
}

interface SortableColumnData
{
    columnIndex: number;
    fieldName: string;
}

interface TransformBrowseData
{
    browseId: string;
    exportType: string;
}

interface BrowseRequestData
{
    condition: string;
    conditionHash: string;
    usageHistoryID: number;
    timestamp: number;
    html: string;
    [key: string]: unknown;
}

interface ChangePageData extends BrowseData
{
    sortField: string;
    sortDescending: boolean | null;
}

interface ResizeBrowseColumnResponse
{
    success: boolean;
    browseViewID?: number;
    browseViewName?: string;
    isModifiedBrowseView?: boolean;
}

interface ResizeBrowseColumnData
{
    column?: number;
    updateBrowseView?: boolean;
}

interface BasePagePageData
{
    pageModule?: string;
    pageObject?: string;
    pageScreen?: string;
    browseName?: string;
    taskName?: string;
    postData?: string;
}

interface ColumnResizeSaveData extends BasePagePageData
{
    columnIndex: number;
    columnWidth: number;
    fieldName: string;
    pageTab?: string;
    browseId?: string;
}

interface InsertColumnPopupSaveData
{
    browseName: string;
    lookupModule?: string;
    lookupObject?: string;
    browseId?: string;
    postData?: string;
}

interface InsertColumnSaveData extends BasePagePageData
{
    columnIndexToInsertAfter: number;
    fieldIsDynamic?: boolean;
    columnFieldName: string;
    isLockedColumn: boolean;
    pageTab?: string;
    browseId?: string;
}

interface DeleteColumnSaveData extends BasePagePageData
{
    fieldName: string;
    columnIndex: number;
    pageTab?: string;
}

interface ColumnSaveData extends BasePagePageData
{
    headerText: string;
    width: number;
    columnIndex: number;
    locked: boolean;
    wrapData: boolean;
    columnViewIndex: number;
    visibilityRestrictedToSuperUsers: boolean;
    pageTab?: string;
}

interface ColumnHeaderPopupData extends BasePagePageData
{
    browseName: string;
    routeModule: string;
    routeObject: string;
    dataModule: string;
    dataObject: string;
    routeHash: string;
    columnViewIndex: number;
    fieldName: string;
    browseSearchCondition?: string;
    browseSearchConditionHash?: string;
    userSearchCondition?: string;
    userSearchConditionHash?: string;
    preventColumnSort?: boolean;
    preventColumnResize?: boolean;
    renderFilterOptions?: boolean;
    browseTempTableName?: string;
}

// TODO - Remove these eventually. JS and server side script builders rely on these still.

/** @deprecated Use browseList utility methods from `#skyward_browseList` instead. */
export const browseList = getBrowseList();

/** @deprecated Use openBrowses utility methods from `#skyward_browseList` instead. */
export const openBrowses = getOpenBrowses();

export {
    /** @deprecated Import directly from `#skyward_browseList` instead. */
    getContainingBrowse,

    /** @deprecated Import directly from `#skyward_browseList` instead. */
    getCurrentBrowseName,

    /** @deprecated Import directly from `#skyward_browseList` instead. */
    getInnerBrowse
};

// END TODO

export const minColumnWidth = 65;
export const maxColumnWidth = 999;

const defaultUpdateCurrentRecordSettings =
{
    loadRelatedBrowses: true,
    updateBrowseSeekInfo: true,
    setCurrentBrowseName: false
};

const allBrowseStats: Record<string, BrowseStats> = {};
let refreshTimeout: number | null = null;
const deselectPreviousRecordOverrides: Dictionary<string, (browseName: string) => boolean> = {};

const keyUpHandler =
{
    _keyUpListeners: {} as Dictionary<number, (event: JQuery.KeyboardEventBase) => void>,
    _boundSharedKeyUpHandler: null as ((event: JQuery.KeyboardEventBase) => void) | null,

    sharedKeyUpHandler(event: JQuery.KeyboardEventBase)
    {
        const listener = this._keyUpListeners[event.which];
        if (!listener)
        {
            return;
        }

        delete this._keyUpListeners[event.which];

        if ($.isEmptyObject(this._keyUpListeners))
        {
            $(document.documentElement).off("keyup", this._boundSharedKeyUpHandler!);
        }

        listener.call(this, event);
    },

    addKeyUpHandler(keyCode: number, expectedBrowseName: string)
    {
        if (this._keyUpListeners[keyCode])
        {
            return;
        }

        if ($.isEmptyObject(this._keyUpListeners))
        {
            this._boundSharedKeyUpHandler ??= this.sharedKeyUpHandler.bind(this);
            $(document.documentElement).on("keyup", this._boundSharedKeyUpHandler);
        }

        this._keyUpListeners[keyCode] = keyUpListener;

        function keyUpListener(event: JQuery.KeyboardEventBase)
        {
            const browse = getCurrentBrowse();
            if (browse?.id !== expectedBrowseName)
            {
                return;
            }
            else if (browse.primaryKeys && browse.primaryKeys.length > 1)
            {
                rowChange(browse.id, browse.currentRow!, true);
            }
            event.stopPropagation();
        }
    }
};

const browseDetailsPanel =
{
    _currentDetailsBrowse: null as string | null, // the name of the browse that is open in the detailsPanel

    get currentDetailsBrowse()
    {
        return this._currentDetailsBrowse;
    },

    set currentDetailsBrowse(value)
    {
        this._currentDetailsBrowse = (value !== null && browseListContains(value)) ? value : null;
    },

    detailsPanelTypes: Object.freeze(
    {
        cell: "cell",
        row: "row"
    }),

    getSelectedRow(getAllRows: boolean)
    {
        if (getAllRows)
        {
            return $(`.${classNames.selectedDetailsRow}`);
        }

        return $(`.${classNames.unlockedBrowseBody}`).find(`.${classNames.selectedDetailsRow}`);
    },

    setSelectedRow(browseName: string)
    {
        this.resetSelectedRow();
        const browse = getBrowseById(browseName);
        if (browse)
        {
            getRowElements(browse).addClass(classNames.selectedDetailsRow);
        }
    },

    resetSelectedRow()
    {
        this.getSelectedRow(true).removeClass(classNames.selectedDetailsRow);
    },

    init()
    {
        const detailsPanelEvents = skyward.detailsPanel?.eventCallbacks as DetailsPanelEvents | undefined;
        if (!detailsPanelEvents)
        {
            return;
        }

        detailsPanelEvents.open.registerCallback((_data: DetailsPanelEventData, additionalData: DetailsPanelAdditionalEventData) =>
        {
            const browseAdditionalData = additionalData as BrowseDetailsPanelAdditionalEventData;
            const browseName = browseAdditionalData.browseName;
            this.currentDetailsBrowse = browseName;
            this.setSelectedRow(this.currentDetailsBrowse);
        });

        detailsPanelEvents.close.registerCallback(() =>
        {
            const currentBrowseName = getCurrentBrowseName()!;
            browseDetailsPanel.currentDetailsBrowse = null;
            browseDetailsPanel.resetSelectedRow();
            if (this.shouldShowDetailsPanelForBrowse(currentBrowseName))
            {
                // If we are reopening a details panel after closing another, add a delay.
                // It is jarring to have one panel close and other instantly reopen
                window.setTimeout(function ()
                {
                    browseDetailsPanel.showDetailsPanel(currentBrowseName, true);
                }, 500);
            }
        });

        detailsPanelEvents.empty.registerCallback(() =>
        {
            this.resetSelectedRow();
            this.removeDetailsPanelBrowsesFromOpenBrowses();
        });

        detailsPanelEvents.resizeClose.registerCallback(() =>
        {
            this.currentDetailsBrowse = null;
            this.resetSelectedRow();
        });

        detailsPanelEvents.resizeOpen.registerCallback((_data: DetailsPanelEventData, additionalData: DetailsPanelAdditionalEventData) =>
        {
            const browseAdditionalData = additionalData as BrowseDetailsPanelAdditionalEventData;

            if (browseAdditionalData.identifier !== valueNames.detailsPanelIdentifier)
            {
                return;
            }
            const browseName = browseAdditionalData.browseName;
            const primaryKey = browseAdditionalData.primaryKey;
            const browseIsStillValid = browseListContains(browseName);
            const currentBrowseName = getCurrentBrowseName()!;
            const isSameBrowse = browseIsStillValid && browseName === currentBrowseName;
            const isSameRow = isSameBrowse && getCurrentRecordTargetId(browseName) === primaryKey;

            if (isSameRow)
            {
                // The record hasn't changed, so the previously opened details panel will be reused
                // (it is already visible when this event is triggered)
                this.currentDetailsBrowse = browseName;
                this.setSelectedRow(browseName);
            }
            else if (this.shouldShowDetailsPanelForBrowse(currentBrowseName))
            {
                // the previous details panel is no longer valid.  Open a new panel for the current browse if it allows it.
                this.showDetailsPanel(currentBrowseName, false);
            }
        });

        detailsPanelEvents.contentLoaded.registerCallback((_data: DetailsPanelEventData, additionalData: DetailsPanelAdditionalEventData) =>
        {
            const browseAdditionalData = additionalData as BrowseDetailsPanelAdditionalEventData;
            const browseName = browseAdditionalData.browseName;
            this.currentDetailsBrowse = browseName;
            this.setSelectedRow(browseName);
        });

        detailsPanelEvents.resizeCanOpen.registerCallback(() =>
        {
            const browse = getCurrentBrowse();
            if (browse && this.shouldShowDetailsPanelForBrowse(browse.id))
            {
                if (browse.isRegistered === true)
                {
                    this.showDetailsPanel(browse.id, false);
                }
                else
                {
                    // finishRegistration() will call tryRefreshDetailsPanel and show the details panel
                    this.currentDetailsBrowse = browse.id;
                }
            }
        });
    },

    showDetailsPanel(browseName: string, shouldAnimate = false)
    {
        const browse = getBrowseById(browseName);
        if (!browse || !this.shouldShowDetailsPanelForBrowse(browseName))
        {
            return $.Deferred().reject();
        }

        const currentRecordID = getCurrentRecordTargetId(browseName);

        if (!(browse.rowModule && browse.rowObject && browse.rowScreen && currentRecordID !== null))
        {
            return $.Deferred().reject();
        }

        const elementData = getUnlockedRowElement(browse).data() as RowElementData;

        setCurrentBrowseName(browseName);

        const module = elementData.rowmodule;
        const object = elementData.rowobject;
        const screen = elementData.rowscreen;
        const postData = this.getDetailsPanelPostData(browse);

        // Clear Confirmation Message data, it is only needed once per details panel
        browse.confirmationMessage = null;
        browse.confirmationMessageContainer = null;

        const detailsPanelOptions =
        {
            shouldAnimate: shouldAnimate,
            panelWidth: elementData.panelwidth,
            additionalData:
            {
                identifier: valueNames.detailsPanelIdentifier,
                browseName: browseName,
                primaryKey: currentRecordID
            }
        };

        this.currentDetailsBrowse = browseName;

        return skyward.detailsPanel.openDetailsPanel(module, object, screen, currentRecordID, postData, detailsPanelOptions).fail(() =>
        {
            this.currentDetailsBrowse = null;
        });
    },

    hideDetailsPanel(shouldAnimate: boolean)
    {
        return skyward.detailsPanel.closeDetailsPanel(shouldAnimate);
    },

    toggleDetailsPanel(browseName: string, shouldAnimate: boolean)
    {
        const isOpen = skyward.detailsPanel.isDetailsPanelOpen();
        skyward.detailsPanel.setDetailsPanelSessionState(!isOpen);

        let promise: JQueryPromise<void> | undefined;

        if (isOpen)
        {
            skyward.detailsPanel.tryCloseDetailsPanel((wasDirty) =>
            {
                if (wasDirty)
                {
                    const deferred = $.Deferred();
                    promise = this.hideDetailsPanel(shouldAnimate).then(() => deferred.resolve(), () => deferred.reject());
                }
                else
                {
                    promise = this.hideDetailsPanel(shouldAnimate);
                }
            });
        }
        else
        {
            promise = this.showDetailsPanel(browseName, shouldAnimate);
        }

        promise?.fail(() =>
        {
            skyward.detailsPanel.setDetailsPanelSessionState(isOpen);
        });
    },

    tryRefreshDetailsPanel(browseName: string)
    {
        const browse = getBrowseById(browseName);

        if (!(browse?.browse) || browse.detailsPanelType !== this.detailsPanelTypes.row)
        {
            return;
        }

        const detailsPanelIsSet = !!this.currentDetailsBrowse;
        const isMainBrowse = browse.browse.hasClass(classNames.mainSelectedBrowse);
        const currentBrowseName = getCurrentBrowseName();
        const isCurrentDetailsPanelBrowse = browseName === this.currentDetailsBrowse && (browseName === currentBrowseName || currentBrowseName === null /* might be behind a workflow */);

        if (isMainBrowse && !detailsPanelIsSet || isCurrentDetailsPanelBrowse)
        {
            this.refreshDetailsPanel(browseName);
        }
    },

    refreshDetailsPanel(browseName: string)
    {
        const shouldAnimate = false;
        if (this.shouldShowDetailsPanelForBrowse(browseName))
        {
            this.showDetailsPanel(browseName, shouldAnimate);
        }
        else
        {
            this.hideDetailsPanel(shouldAnimate);
        }
    },

    tryRowChange(browseName: string, doChangeRowCallback: () => void, shouldShowDetailsPanel: boolean)
    {
        if (!this.shouldShowDetailsPanelForBrowse(browseName))
        {
            if (this.shouldHideDetailsPanelForBrowse(browseName))
            {
                skyward.detailsPanel.tryCloseDetailsPanel(() =>
                {
                    this.hideDetailsPanel(true);
                    doChangeRowCallback();
                });
            }
            else
            {
                doChangeRowCallback();
            }
            return;
        }

        const changeRowAndShowDetailsPanel = () =>
        {
            doChangeRowCallback();
            if (shouldShowDetailsPanel)
            {
                this.showDetailsPanel(browseName);
            }
        };

        skyward.detailsPanel.tryCloseDetailsPanel((wasDirty) =>
        {
            if (wasDirty)
            {
                changeRowAndShowDetailsPanel();
            }
            else if (skyward.detailsPanel.getDetailsPanelSessionState())
            {
                changeRowAndShowDetailsPanel();
            }
            else
            {
                doChangeRowCallback();
            }
        });
    },

    detailsPanelSaveUpdateRow(data: Record<string, unknown>)
    {
        const browse = getBrowseById(this.currentDetailsBrowse);
        if (!browse)
        {
            return;
        }

        const postData = $.extend({}, this.getDetailsPanelPostData(browse), data);

        return get(this.currentDetailsBrowse!, { seekId: browse.primaryKeys![browse.currentRow!] }, postData);
    },

    setDetailsPanelTabData(tabData: TabData)
    {
        const browse = getBrowseById(this.currentDetailsBrowse);
        if (!browse)
        {
            return;
        }

        browse.tabData = tabData;
    },

    /**
     * Checks if the browse for the browse name provided should allow row-level details panels to be opened.
     * @param browseName - The name of the browse to check.
     * @returns True if the browse should allow row-level details panels to be opened.
     */
    shouldShowDetailsPanelForBrowse(browseName: string)
    {
        const browse = getBrowseById(browseName);
        if (!browse)
        {
            return false;
        }

        //if any of these conditions are true the detailsPanel can't be displayed
        const conditionsToNotShowDetailsPanel =
        [
            browse.hidePreviewDetailsButton, //details button is hidden for the browse
            isInWorkflow(browse),
            browse.isInDetailsPanel,
            elementIsInModalLayer(browse.browse!),
            !skyward.detailsPanel.getDetailsPanelSessionState(), // details panel session state is Closed
            !skyward.detailsPanel.canShowDetailsPanel(), // window is too small to show details panel,
            browse.detailsPanelType !== this.detailsPanelTypes.row,
            !(browse.rowModule && browse.rowObject && browse.rowScreen)
        ];

        return !conditionsToNotShowDetailsPanel.includes(true);
    },

    /**
     * Checks if the browse for the browse name provided should automatically
     * close an open details panel when it becomes the active browse.
     * @param browseName - The name of the browse to check.
     * @returns True if the browse should automatically close an open details panel when it becomes the active browse.
     */
    shouldHideDetailsPanelForBrowse(browseName: string)
    {
        const browse = getBrowseById(browseName);
        if (!browse)
        {
            return false;
        }

        const detailsPanelData = skyward.detailsPanel.getData();
        // if any of these conditions are true the detailsPanel can't be closed
        const conditionsToNotHideDetailsPanel =
        [
            isInWorkflow(browse),
            browse.isInDetailsPanel,
            elementIsInModalLayer(browse.browse!),
            // the details panel has it's own close button, the browse shouldn't close it automatically
            !$.isEmptyObject(detailsPanelData) && !$.isEmptyObject(detailsPanelData.options) && detailsPanelData.options.useCloseButton === true
        ];

        return !conditionsToNotHideDetailsPanel.includes(true);
    },

    removeDetailsPanelBrowsesFromOpenBrowses()
    {
        filterOpenBrowses((browseName) => !browseName.startsWith("detailsPanel_"));
    },

    getDetailsPanelPostData(browse: Browse)
    {
        const data: DetailsPanelPostData =
        {
            renderInDetailsPanel: true,
            confirmationMessage: browse.confirmationMessage,
            confirmationMessageContainer: browse.confirmationMessageContainer
        };

        const currentRow = getUnlockedRowElement(browse);

        if (currentRow.length > 0)
        {
            $.extend(data, currentRow.data("postdata"));
        }

        if (browse.tabData?.tabType === "details")
        {
            data.tab = browse.tabData.tab;
        }
        return data;
    }
};

export const detailsPanelSaveUpdateRow = browseDetailsPanel.detailsPanelSaveUpdateRow.bind(browseDetailsPanel);
export const tryRefreshDetailsPanel = browseDetailsPanel.tryRefreshDetailsPanel.bind(browseDetailsPanel);

const rowClickThrottler =
{
    _rateLimit: 10, //ms
    _timeOutHandler: null as number | null,

    throttleRowClick(browseName: string, browseCell: JQuery)
    {
        if (this._timeOutHandler)
        {
            return;
        }
        rowClick(browseName, browseCell);
        this._timeOutHandler = window.setTimeout(() =>
        {
            this._timeOutHandler = null;
        }, this._rateLimit);
    }
};

export function resizeBrowseList()
{
    for (const browseName of getAllBrowseIds())
    {
        try
        {
            const browse = getBrowseById(browseName);
            if (browse?.resize)
            {
                browse.resize();
            }
        }
        catch
        {
            removeBrowse(browseName);
        }
    }
}

export function isInWorkflow(browse: Browse)
{
    return !!browse.taskName;
}

export function setDetailsPanelTabData(tabData: TabData)
{
    browseDetailsPanel.setDetailsPanelTabData(tabData);
}

export function getCurrentRowElement(rowType: string, browseName: string, rowNumber: number, browseType?: BrowseType)
{
    const idPrefix = `#${browseName}_`;

    if (browseType === "Tile")
    {
        return $(`${idPrefix}Tile${rowNumber}`);
    }
    else if (browseType === "DistinctMultiSelect" && rowNumber === -1)
    {
        return $(`${idPrefix}${rowType}Header`).find(`.${classNames.massSelectCell}`);
    }

    // rowType should be "unlocked" or "locked"
    return $(`${idPrefix}${rowType}Row${rowNumber}`);
}

export function registerDeselectPreviousRecordOverrideListener(browseName: string, callback: (browseName: string) => boolean)
{
    deselectPreviousRecordOverrides[browseName] = callback;
}

export function deregisterDeselectPreviousRecordOverrideListener(browseName: string)
{
    delete deselectPreviousRecordOverrides[browseName];
}

export function setCurrentRecord(browseName: string, rowNumber: string | number | null | undefined, options: Record<string, unknown> = {})
{
    const browse = getBrowseById(browseName)!;
    const row = parseInt(rowNumber as string);
    // browse.currentRow may be undefined for Gradebook.  We want to invalidate in that case.
    const isBrowseValid = !$.isEmptyObject(browse) && browse.currentRow !== undefined;
    // DMSE is allowed to have a negative row number
    const isRowValid = isBrowseValid && !isNaN(row) && (row >= 0 || browse.browseType === "DistinctMultiSelect");

    if (!isRowValid)
    {
        return;
    }

    const settings = $.extend({}, defaultUpdateCurrentRecordSettings, options);
    const recordChanged = row !== browse.currentRow;
    const lockedRow = getLockedRowElement(browse, row);
    const unlockedRow = getUnlockedRowElement(browse, row);
    const unlockedBody = $(`#${browseName}_unlockedBody`);

    if (unlockedBody.length > 0 && unlockedRow.length > 0)
    {
        const bodyTop = unlockedBody.scrollTop()!;
        const bodyBottom = bodyTop + unlockedBody.height()!;
        const rowTop = unlockedRow.offset()!.top - unlockedBody.offset()!.top + bodyTop;
        const rowBottom = rowTop + unlockedRow.height()!;

        if (rowTop < bodyTop)
        {
            scrollRowIntoView(true);
        }
        else if (rowBottom > bodyBottom)
        {
            scrollRowIntoView(false);
        }
    }

    let addRowHighlighting = false;

    if (recordChanged && !isDeselectPreviousRecordOverridden(browseName))
    {
        deselectPreviousRecord(browseName);
        addRowHighlighting = !browse.disableRowHighlighting;
    }

    browse.currentRow = row;

    const browseElement = $(`#${browseName}`);

    browseElement.children(`.${classNames.selectedPK}`).val(browse.primaryKeys![row]);

    if (addRowHighlighting)
    {
        const rows = lockedRow.add(unlockedRow);
        if (rows.length > 0)
        {
            rows.addClass(classNames.current);
            rows.find("svg").addClass(classNames.browseRowContent);
            rows.eq(-1).attr("aria-selected", "true");
        }
    }

    if (browse.relatedBrowses && settings.loadRelatedBrowses)
    {
        getRelatedBrowses(browse);
    }

    // When paging forward/back, if you were on the first row, the row number will be unchanged and recordChanged will be false.
    // We still want to save the browse seek ID in that case, otherwise you will be taken to your prior seek position when you
    // reload the page.
    if (settings.updateBrowseSeekInfo)
    {
        save(browse);
    }

    if (settings.setCurrentBrowseName)
    {
        setCurrentBrowseName(browseName);
    }

    if (recordChanged)
    {
        browseElement.trigger("rowChanged", browse);
    }

    return recordChanged;

    function scrollRowIntoView(alignToTop: boolean)
    {
        unlockedRow[0].scrollIntoView(alignToTop);

        if (lockedRow.length)
        {
            lockedRow[0].scrollIntoView(alignToTop);
        }
    }
}

interface RegisterBrowseOptions
{
    browseRequestName: string;
    browseName: string;
    browseViewId: number | string | null;
    browseId: number | string | null;
    recordCount: number;
    currentRow: number | null;
    primaryKeys: number[];
    columnFieldNames: string[];
    browseFilterId: number | string | null;
    browseFilterIdHash: string | null;
    browseSearchCondition: string | null;
    browseSearchConditionHash: string | null;
    userSearchCondition: string | null;
    userSearchConditionHash: string | null;
    codeEelSearchText: string | null;
    selectMode: boolean;
    rowModule: string | null;
    rowObject: string | null;
    rowScreen: string | null;
    taskName: string | null;
    hidePreviewDetailsButton: boolean;
    hideBrowseControl: boolean;
    hideSelectListTotals: boolean;
    hasCollapseExpandButton: boolean;
    renderLeftControls: boolean;
    renderSearchBox: boolean;
    renderViewButton: boolean;
    renderFilterButton: boolean;
    renderLiveTileAddButton: boolean;
    renderChartTileAddButton: boolean;
    rowData: Dictionary<string, unknown[]> | null;
    rowDataHash: string[] | null;
    disableBrowseSort: boolean;
    hideOptionsButton: boolean;
    hideReportsFromRelatedScreen: boolean;
    tempTableName: string | null;
    confirmationMessage: string | null;
    confirmationMessageContainer: string | null;
    renderHeaderSettings: boolean;
    renderSortableHeader: boolean;
    preventColumnResize: boolean;
    detailsPanelType: DetailsPanelType;
    firstRowIdentityFieldValues: string | null;
    lastRowIdentityFieldValues: string | null;
    renderRowsPerPageOption: boolean;
    forceSingleThread: boolean;
    skywardID: string | number | null;
    rowsPerPageCap: number | null;
    isRelatedBrowse: boolean;
}

export function registerBrowse(options: RegisterBrowseOptions)
{
    const browseName = options.browseName;

    const thisBrowse = getBrowseById(browseName);
    if (!thisBrowse)
    {
        return;
    }

    thisBrowse.data ??= {};
    const browseHtmlId = `#${browseName}`;
    const browseContainer = thisBrowse.browse ? $(thisBrowse.browse) : $(browseHtmlId);

    if (shouldProcessMobileBrowse(thisBrowse))
    {
        // Move scripts out of the browse before converting to an HTML string.  Otherwise, when we convert
        // it back, jQuery will synchronously load them.
        const scripts = browseContainer.find("script");
        // TODO (6503565) make sure this runs the correct number of times
        document.body.append(...scripts.get());

        initMobileBrowse(browseContainer, browseContainer.html(), thisBrowse);
    }

    const oldTotalData = thisBrowse.totals ?? {};

    const isInDetailsPanel = browseContainer.hasClass(classNames.isInDetailsPanel);

    // Only bind cleanup events on the initial registration of the browse
    if (thisBrowse.isRegistered === undefined || !thisBrowse.isRegistered)
    {
        bindBrowseCleanupEvents(browseName, thisBrowse, browseContainer, isInDetailsPanel);
    }

    $.extend(thisBrowse,
    {
        browse: browseContainer,
        controls: $(`${browseHtmlId}_controls`),
        quickFilter: browseContainer.find(`.${classNames.expandableQuickFilter}`),
        seek: $(`${browseHtmlId}_seek`),
        searchContainer: browseContainer.find(`.${classNames.browseSearch}`),
        header: $(`${browseHtmlId}_header`),
        lockedHeader: $(`${browseHtmlId}_lockedHeader`),
        unlockedHeader: $(`${browseHtmlId}_unlockedHeader`),
        body: $(`${browseHtmlId}_body`),
        lockedBody: $(`${browseHtmlId}_lockedBody`),
        unlockedBody: $(`${browseHtmlId}_unlockedBody`),
        footer: $(`${browseHtmlId}_footer`),
        baseErrorDiv: browseContainer.find(`.${classNames.currentRecordContentBaseError}`),
        viewId: options.browseViewId,
        browseId: options.browseId,
        browseName: options.browseRequestName,
        recordCount: options.recordCount,
        currentRow: options.currentRow,
        primaryKeys: options.primaryKeys,
        columnFieldNames: options.columnFieldNames,
        contentMessageArea: undefined,
        browseFilterId: options.browseFilterId,
        browseFilterIdHash: options.browseFilterIdHash,
        browseSearchCondition: options.browseSearchCondition,
        browseSearchConditionHash: options.browseSearchConditionHash,
        userSearchCondition: options.userSearchCondition,
        userSearchConditionHash: options.userSearchConditionHash,
        selectMode: options.selectMode,
        sectionHeaderContainer: browseContainer.find(`.${classNames.sectionHeader}`),
        hidePreviewDetailsButton: options.hidePreviewDetailsButton,
        rowModule: options.rowModule,
        rowObject: options.rowObject,
        rowScreen: options.rowScreen,
        taskName: options.taskName,
        hideBrowseControl: options.hideBrowseControl,
        hideSelectListTotals: options.hideSelectListTotals,
        rowsPerPageCap: options.rowsPerPageCap,
        hasCollapseExpandButton: options.hasCollapseExpandButton,
        rowData: options.rowData ? (new FieldTree(options.rowData).next().value as { values: unknown[] }).values : [],
        rowDataHash: options.rowDataHash,
        codeEELSearchText: options.codeEelSearchText,
        renderLeftControls: options.renderLeftControls,
        renderSearchBox: options.renderSearchBox,
        renderViewButton: options.renderViewButton,
        renderFilterButton: options.renderFilterButton,
        renderLiveTileAddButton: options.renderLiveTileAddButton,
        renderChartTileAddButton: options.renderChartTileAddButton,
        disableBrowseSort: options.disableBrowseSort,
        hideOptionsButton: options.hideOptionsButton,
        hideReportsFromRelatedScreen: options.hideReportsFromRelatedScreen,
        tempTableName: options.tempTableName,
        confirmationMessageContainer: options.confirmationMessageContainer,
        confirmationMessage: options.confirmationMessage,
        renderHeaderSettings: options.renderHeaderSettings,
        renderSortableHeader: options.renderSortableHeader,
        preventColumnResize: options.preventColumnResize,
        isInDetailsPanel: isInDetailsPanel,
        detailsPanelType: options.detailsPanelType,
        firstRowIdentityFieldValues: options.firstRowIdentityFieldValues,
        lastRowIdentityFieldValues: options.lastRowIdentityFieldValues,
        renderRowsPerPageOption: options.renderRowsPerPageOption,
        forceSingleThread: options.forceSingleThread,
        hasShadow: false,
        totals: $.extend(oldTotalData,
        {
            container: browseContainer.find(`.${classNames.browseBodyTotalsSection}`)
        }),
        cachedSql: null,
        skywardID: options.skywardID,
        isRegistered: false,
        rowCount: null,
        isRelatedBrowse: options.isRelatedBrowse
    });

    preInitQuickFilter(thisBrowse);

    const browseSearchBox = browseContainer.find(`.${classNames.browseSearchBox}`);

    browseSearchBox.on("keydown", function (e)
    {
        const eventKeys = skyward.keys.getKeyNamesFromEvent(e);

        if (eventKeys.ENTER)
        {
            if ($(`.${classNames.dateTimePickerModal}`).length > 0)
            {
                // If there is a Date/Time/DateTime Picker modal open, do not search until it's closed.
                return;
            }

            const element = $(this);
            browseSearchClickEventHandler.apply(element);

            e.stopPropagation();
            e.preventDefault();
        }
    });

    browseContainer.find(`.${classNames.searchBoxButton}`).on("click", browseSearchClickEventHandler);
    setupBrowseDependency(thisBrowse);
    updateBrowseTotalsRequest(thisBrowse);
    addBrowseScrollEvents(thisBrowse);
    wireUpExpandCollapseBrowseButton(thisBrowse.browse!);
    addBrowseControlsClickEvents(thisBrowse);
    addBrowseBodyClickEvents(thisBrowse);
    addQuickSelectionFilter(thisBrowse);
    addColumnHeaderClickEvents(thisBrowse);
    addColumnHeaderResizeHandler(thisBrowse);
    if (thisBrowse.preventColumnResize !== true)
    {
        addColumnHeaderResizeEvents(thisBrowse.browse!, browseName);
    }
    addPagingButtonClickEvents(browseName);
    addTotalRecordsClickEvents(browseName);

    thisBrowse.params = [];

    browseContainer.append(`<input id="${browseName}_selectedPK" name="${browseName}_selectedPK" class="${classNames.selectedPK}" type="hidden" />`);

    browseContainer.off("click", `.${classNames.browseRow} .${classNames.browseDataCell}`);

    browseContainer.on("click", `.${classNames.browseRow} .${classNames.browseDataCell}`, function ()
    {
        rowClickThrottler.throttleRowClick(browseName, $(this));
    });

    browseContainer.off("click", `.${classNames.lockedBrowseBody} .${classNames.browseRow} .${classNames.browseRowOptions}`);
    browseContainer.on("click", `.${classNames.lockedBrowseBody} .${classNames.browseRow} .${classNames.browseRowOptions}`, function (event)
    {
        //We have to add the event listener to the locked div because it is on top, but we need to select the unlocked row.
        //If a browse row button is clicked (child of the .browseRowOptions div) we want to let the button click function happen and not trigger the rowclick
        if (event.target)
        {
            const eventTarget = $(event.target);
            if (eventTarget.hasClass(classNames.button) || eventTarget.parents(`.${classNames.button}`).length > 0)
            {
                return;
            }
        }
        const lockedBrowseRow = $(this).parent();
        if (lockedBrowseRow.length > 0)
        {
            const unlockedRowID = lockedBrowseRow.attr("id")?.replace("locked", "unlocked");
            const unlockedBrowseRow = $(`#${unlockedRowID}`);
            const browseCell = unlockedBrowseRow.find(`.${classNames.browseRowOptions}`);
            rowClick(browseName, browseCell);
        }
    });

    browseContainer.off("click", `.${classNames.insertColumnButton}`, noColumnsInsertColumnButtonClick);
    browseContainer.on("click", `.${classNames.insertColumnButton}`, noColumnsInsertColumnButtonClick);

    const openBrowseFilterDialogFor = new URLSearchParams(window.location.search).get("openBrowseFilterDialogFor");
    if (openBrowseFilterDialogFor && thisBrowse.browseName === openBrowseFilterDialogFor)
    {
        $(`#${thisBrowse.browseName}_filterButton`).trigger("click");
    }

    function browseSearchClickEventHandler()
    {
        const searchText = getSearchTextValue(browseName);
        let tempTable = null;
        const browse = getBrowseById(browseName);
        if (browse)
        {
            tempTable = browse.tempTableName;
        }

        performSearch(browseName, { seekText: searchText, tempTableName: tempTable });
    }
}

export function hide(browseContainerID: string)
{
    const browseContainer = $(`#${browseContainerID}`);
    if (browseContainer.length > 0)
    {
        browseContainer.parent().css("display", "none");
    }
}

export function show(browseContainerID: string)
{
    const browseContainer = $(`#${browseContainerID}`);
    if (browseContainer.length > 0)
    {
        browseContainer.parent().css("display", "");
    }
}

export const resize = browseResize;

export function rowPopupMenu(rowMenuData: MenuItemDefinition[], browseName: string, button: JQuery, rowNumber: number)
{
    const currentBrowse = getBrowseById(browseName);

    if (currentBrowse && currentBrowse.currentRow !== rowNumber)
    {
        skyward.detailsPanel.tryCloseDetailsPanel(function ()
        {
            doRowPopup();
        });
    }
    else
    {
        doRowPopup();
    }

    function doRowPopup()
    {
        button = $(button);

        const differentBrowseClicked = getCurrentBrowseName() !== browseName;

        setCurrentBrowseName(browseName);

        const browse = getBrowseById(browseName);

        if (browse?.detailsPanelType === browseDetailsPanel.detailsPanelTypes.row && (browse.currentRow !== rowNumber || differentBrowseClicked))
        {
            if (browse.currentRow !== rowNumber)
            {
                setCurrentRecord(browseName, rowNumber);
            }

            if (!browse.hidePreviewDetailsButton)
            {
                browseDetailsPanel.showDetailsPanel(browseName);
            }
        }

        const modalPopUpItems: MenuItemDefinition[] = [];

        $.each(rowMenuData, function (_, value)
        {
            if (value.type === "title")
            {
                modalPopUpItems.push(value);
            }
            else
            {
                createModalObject(value);
            }
        });

        showMenu(modalPopUpItems, button, {});

        function createModalObject(value: MenuItemDefinition)
        {
            const attributes: Record<string, string> = {};
            for (const [prop, dataValue] of Object.entries(value.data ?? {}))
            {
                attributes[`data-${prop}`] = dataValue as string;
            }

            const menuItem: MenuItemDefinition =
            {
                type: "item",
                text: value.text,
                icon: value.icon,
                click: function (this: HTMLElement, event: JQuery.ClickEvent)
                {
                    const data = value.data ?? {};
                    const clickTargetId = data["click-target-id"] as string | undefined;
                    const clickAction = data["click-action"] as string | undefined;

                    if (clickTargetId && clickTargetId !== "")
                    {
                        $(`#${clickTargetId}`).trigger("click");
                    }
                    else if (clickAction && clickAction !== "")
                    {
                        clickEvent.call(this, event);
                    }
                    else
                    {
                        loadContent(value.target!, value.module!, value.object!, value.screen!, value.id, data, null, undefined);
                    }
                },
                attributes: attributes
            };
            modalPopUpItems.push(menuItem);
        }
    }
}

export function handlePopupBrowseTabPress()
{
    const browse = getCurrentBrowse();
    if (!browse)
    {
        return;
    }

    if (browse.recordCount !== undefined && browse.recordCount > 0)
    {
        $(browse.body!).find(`.${classNames.browseRow}.${classNames.current} a.${classNames.button}`).first().trigger("focus");
    }
    else
    {
        $(browse.browse!).find(`a.${classNames.button}`).first().trigger("focus");
    }
}

/**
 * Creates a new collection from browse and browseData to form a (more) complete settings/data collection for POST
 * @param dependencies Snapshot of browse.dynamicFilterData's dependencies. Without one, they're read without waiting.
 */
export function getRequiredBrowseData(browse: Browse, browseData: Partial<BrowseData & SeekInfo & BrowseColumnData> = {}, dependencies?: DependencySnapshot)
{
    const parentBrowse = getParentBrowse(browse);

    const data: BrowsePostData =
    {
        pageModule: browse.pageModule, // The module of the screen the browse appears on
        pageObject: browse.pageObject,
        pageScreen: browse.pageScreen,
        pageTab: browse.pageTab,
        routeModule: browse.routeModule, // The module specified by the browse viewpart, usually determined by the route module (area)
        routeObject: browse.routeObject,
        dataModule: browse.dataModule, // The module of the data object that the browse is based on
        dataObject: browse.dataObject,
        taskName: browse.taskName ?? undefined,
        browseName: browse.browseName,
        hidePrimaryBrowseButton: !!browseData.hidePrimaryBrowseButton || browse.hidePrimaryBrowseButton,
        labelID: browse.labelID,
        hideIfEmpty: !!browse.hideIfEmpty || !!parentBrowse?.hideIfEmpty,
        selectMode: browse.selectMode,
        browseId: browse.id,
        isCodeEel: browse.isCodeEel ?? false,
        codeEelName: browse.codeEelName ?? undefined,
        codeEelCode: browse.codeEelCode ?? undefined,
        codeEelDescription: browseData.codeEelDescription ?? undefined,
        codeEELSearchText: browse.codeEELSearchText ?? undefined,
        relatedBrowses: browse.relatedBrowses != null ? JSON.stringify(browse.relatedBrowses) : undefined,
        rowDataDefinitions: browse.rowDataDefinitions != null ? JSON.stringify(browse.rowDataDefinitions) : undefined,
        queryParameterData: browse.queryParameterData != null ? JSON.stringify(browse.queryParameterData) : undefined,
        queryParameterDataHash: browse.queryParameterDataHash ?? undefined,
        timestamp: new Date().getTime(),
        tempTableName: browseData.tempTableName ?? browse.tempTableName ?? undefined,
        displayName: browse.displayName ?? browseData.displayName,
        dynamicHeight: browse.dynamicHeight,
        readNoLock: browseData.readNoLock ? true : false,
        hideBrowseControl: browse.hideBrowseControl,
        hideSelectListTotals: browse.hideSelectListTotals,
        rowsPerPageCap: browse.rowsPerPageCap,
        renderSearchBox: browse.renderSearchBox,
        performSearch: true,
        getBrowseSearchMode: browse.getBrowseSearchMode,
        multiSelectBrowseObjectRelationship: browse.multiSelectBrowseObjectRelationship,
        multiSelectBrowseObjectRelationshipField: browse.multiSelectBrowseObjectRelationshipField,
        multiSelectBrowseContextId: browse.multiSelectBrowseContextId,
        multiSelectBrowseIsReverseRelationship: browse.multiSelectBrowseIsReverseRelationship,
        segmentedBrowseParentField: browse.segmentedBrowseParentField,
        segmentedRowHeaderDisplayData: browse.segmentedRowHeaderDisplayData != null ? JSON.stringify(browse.segmentedRowHeaderDisplayData) : undefined,
        dataType: browseData.dataType,
        browseFilterId: browseData.browseFilterId,
        hasCollapseExpandButton: browse.hasCollapseExpandButton,
        requestDataHash: browse.requestDataHash,
        disableRowHighlighting: browse.disableRowHighlighting,
        preventColumnResize: browse.preventColumnResize,
        preventColumnSort: browse.preventColumnSort,
        renderLeftControls: browse.renderLeftControls,
        renderViewButton: browse.renderViewButton,
        renderFilterButton: browse.renderFilterButton,
        renderLiveTileAddButton: browse.renderLiveTileAddButton && !browse.isRelatedBrowse,
        renderChartTileAddButton: browse.renderChartTileAddButton && !browse.isRelatedBrowse,
        renderRowsPerPageOption: browse.renderRowsPerPageOption,
        disableBrowseSort: browse.disableBrowseSort,
        hideOptionsButton: browse.hideOptionsButton,
        hideReportsFromRelatedScreen: browse.hideReportsFromRelatedScreen,
        additionalfieldinfo: browse.additionalfieldinfo,
        sortfieldinfo: browse.sortfieldinfo,
        distinctfield: browse.distinctfield,
        hidedistinctfield: browse.hidedistinctfield,
        rendernodatarow: browse.rendernodatarow,
        distinctfieldwidth: browse.distinctfieldwidth,
        selectedItemKeys: browse.selectedItemKeys,
        dependentFilterPromptValues: browse.dependentFilterPromptValues,
        promptIsList: browse.promptIsList,
        filter: browse.filter,
        renderDesignReportButton: browse.renderDesignReportButton,
        parentPrimaryKeyID: browseData.parentPrimaryKeyID ?? undefined,
        hideMoreMenuArea: !!browse.hideMoreMenuArea,
        renderSortableHeader: browse.renderSortableHeader,
        renderHeaderSettings: browse.renderHeaderSettings,
        isOnTheFly: browse.isOnTheFly,
        hiddenBackingDataId: browse.hiddenBackingDataId,
        detailsPanelType: browse.detailsPanelType,
        pagingType: browseData.pagingType,
        identifyingFieldsAndValues: encodeHtml(getIdentityFieldValuesBasedOnType(browseData.pagingType!, browse)),
        identityFieldValuesOfTopRecord: encodeHtml(browse.firstRowIdentityFieldValues),
        seekText: getSearchTextValue(browse.id),
        renderQuickFilter: browse.renderQuickFilter && !browse.isRelatedBrowse && !browse.isInDetailsPanel && browse.browse?.closest(`.${classNames.workflow}`).length === 0,
        headerNumber: getHeaderNumber(browse),
        // TODO (6114748) make rowdata and parentBrowseRequestDataHash a special case of dynamicFilterHashes
        parentBrowseRequestDataHash: parentBrowse?.requestDataHash,
        forceSingleThread: !!browse.forceSingleThread || !!browseData.forceSingleThread,
        rowDataNonce: browse.rowDataNonce,
        isRelatedBrowse: browseData.isRelatedBrowse ?? browse.isRelatedBrowse
    };

    const parentRow = parentBrowse?.currentRow;
    if (typeof parentRow === "number" && parentRow >= 0 && parentBrowse?.rowData)
    {
        const rowDataToPost = (parentBrowse.rowData as Record<number, unknown>)[parentRow];
        if (!$.isEmptyObject(rowDataToPost))
        {
            data.rowData = JSON.stringify(rowDataToPost);
            data.rowDataHash = parentBrowse.rowDataHash![parentRow];
        }
    }
    else if (parentBrowse)
    {
        // parent browse is empty
        // Row 0 has the special "no data" hash
        data.rowDataHash = parentBrowse.rowDataHash![0];
    }

    if (browse.dynamicFilterValues || browse.dynamicFilterData)
    {
        // dynamicFilterValues: { [postdata key]: postdata value } dictionary assigned by browse subclasses or by Dynamic Search Conditions in Browse.cs
        // dynamicFilterData: comma-separated postdata key & controlID values assigned based on <Dependency> elements in sxl or BaseBrowse.BaseDependency in C#
        // dynamicFilterHashes: { [key]: hash } dictionary covering both sets of values
        // TODO (6756543) wait for dependencies on paging, sorting, and dependency updates
        const dynamicDependencyData = dependencies ?? getDependencyDataWithoutWaiting(browse.dynamicFilterData as TextBoxData, getScopeContainer(browse.browse as JQueryInput));
        data.dynamicFilterValues = JSON.stringify($.extend({}, browse.dynamicFilterValues, dynamicDependencyData));
        data.dynamicFilterHashes = JSON.stringify(browse.dynamicFilterHashes ?? {});
    }

    if (browse.data)
    {
        const postData = browse.data;
        data.postData = JSON.stringify(postData);
    }

    $.extend(data, getBrowseTypeSpecificData(browse));

    $.extend(data, setAndGet(browse, browseData));

    if (!data.hidePrimaryBrowseButton)
    {
        const parentBrowseIsEmpty = parentBrowse && parentBrowse.primaryKeys?.length === 0;
        data.hidePrimaryBrowseButton = parentBrowseIsEmpty;
    }

    return data;
}

export async function get(browseId: string, browseData?: BrowseData, moreData?: BrowseData | null)
{
    const browse = getBrowseById(browseId);
    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    if (browse.data?.filter)
    {
        browse.data.filter = encodeHtml(browse.data.filter as string);
    }

    let dependencies: DependencySnapshot | undefined;
    if (browse.dynamicFilterValues || browse.dynamicFilterData)
    {
        dependencies = await waitForDependencies(browse.dynamicFilterData as TextBoxData, getScopeContainer(browse.browse as JQueryInput));
    }

    let data = getRequiredBrowseData(browse, browseData, dependencies);

    if (moreData)
    {
        data = $.extend({}, data, moreData);
    }

    data.performSearch = browse.getBrowseSearchMode === undefined || browse.getBrowseSearchMode === "Always";

    // We only want to return the Search Condition if we are trying to get it to store on a Dashboard Item's parameters
    const urlParams = new URLSearchParams(window.location.search);
    data.returnSearchCondition = urlParams.get("returnSearchCondition") === "true";

    const urlBrowseFilterID = urlParams.get("browseFilterId");
    if (urlBrowseFilterID && !isNaN(urlBrowseFilterID as unknown as number))
    {
        data.browseFilterId = urlBrowseFilterID;
    }

    return requestBrowse(browseId, browse, data, "GetBrowse");
}

export function changeView(browseId: string, browseData?: BrowseData, additionalPostData?: BrowseData)
{
    const browse = getBrowseById(browseId);
    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const data = getRequiredBrowseData(browse, browseData);
    let postData = data;

    if (!$.isEmptyObject(additionalPostData))
    {
        postData = $.extend({}, additionalPostData, data);
    }

    postData.viewId = browseData?.viewId;
    postData.seekId = -1;

    return requestBrowse(browseId, browse, postData, "ChangeBrowseView");
}

export function changeFilter(browseId: string, browseData: BrowseData)
{
    const browse = getBrowseById(browseId);

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const data = getRequiredBrowseData(browse, browseData);
    data.currentPage = browseData.currentPage;
    data.seekId = -1;

    return requestBrowse(browseId, browse, data, "ChangeBrowseFilter");
}

export function updateQuickFilter(browseId: string, filterData: string)
{
    const browse = getBrowseById(browseId);

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const data = getRequiredBrowseData(browse);
    data.seekId = -1;
    data.filter = filterData;

    return requestBrowse(browseId, browse, data, "UpdateFilterAndView");
}

/**
 * Change the page of the browse. If browseData is not passed, it will be pulled from the element's data attributes. This allows paging buttons to call this function directly without needing to know about the browseData object.
 * @param element - The paging button that was clicked, used to pull browseData from its data attributes if browseData is not passed as an argument
 * @param browseId - The ID of the browse to page, used to get the browse if browseData is not passed as an argument
 * @param browseData - Optional data object containing information about the browse and the page to navigate to. If not passed, this information will be pulled from the data attributes of the element argument
 */
export function changePage(element: JQueryInput | null, browseId: string, browseData?: BrowseData)
{
    let browse;
    let localBrowseData = browseData;
    if (localBrowseData === undefined)
    {
        const pagingButtonData = $(element!).data();
        localBrowseData = pagingButtonData;
        browse = getContainingBrowse(element!);
    }
    else
    {
        browse = getBrowseById(browseId);
    }

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const data = getRequiredBrowseData(browse, localBrowseData);
    data.seekId = -1;
    data.currentPage = localBrowseData.currentPage;
    return requestBrowse(browse.id, browse, data, "ChangeBrowsePage");
}

function updateDependency(this: JQuery | void, browseId: string): JQuery.Promise<void>
{
    let browse;
    let browseData;
    if (this)
    {
        const pagingButtonData = $(this as JQuery).data();
        browseData = pagingButtonData;
        browse = getContainingBrowse(this as JQuery);
    }
    else
    {
        browse = getBrowseById(browseId);
    }

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    // If the browse hasn't loaded yet, there is nothing to update. In addition setupBrowseDependency() hasn't run so
    // we can't populate dynamicFilterValues. Don't bother sending a request.
    if (!browse.browse?.children().length)
    {
        return $.Deferred().resolve().promise();
    }
    browse.dynamicFilterValues ??= {};

    // Add editable dependency to browse data
    for (const [key, value] of Object.entries(browseData?.dependencyPostData as Record<string, unknown> ?? {}))
    {
        browse.dynamicFilterValues[key] = value;
    }

    const data = getRequiredBrowseData(browse, browseData);
    data.seekId = -1;
    data.currentPage = browseData?.currentPage;

    if (browse.browseType === "Checkbox")
    {
        // Reset CheckboxBrowse State
        data.resetValues = true;
    }

    return requestBrowse(browse.id, browse, data, "ChangeBrowsePage").then(() => {});
}

export function changeRowsPerPage(browseId: string, browseData: ChangeRowsPerPageData)
{
    const browse = getBrowseById(browseId);

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const data = getRequiredBrowseData(browse, browseData);
    browse.rowsPerPage = browseData.rowsPerPage;
    data.rowsPerPage = browseData.rowsPerPage;

    return requestBrowse(browseId, browse, data, "ChangeBrowseRowsPerPage");
}

export async function resetViewAndFilter(browseViewId: string, browseFilterId: string, browseId: string, data?: BrowseData)
{
    const postData = $.extend({}, data,
    {
        browseViewID: browseViewId,
        browseFilterID: browseFilterId
    });

    const response = await $.ajax(
    {
        url: `${virtualDir}SkySys/BrowseView/ResetViewAndFilter`,
        type: "POST",
        dataType: "JSON",
        data: postData
    }) as ResetViewAndFilterResponse;

    if (response.success)
    {
        // Even though we update the filter and view on this browse for the user, calling
        // changeView() will cause the browse to reload, taking care of the changed view and filter.
        changeView(browseId, { viewId: response.browseViewId });
    }
}

/**
 * Update the height of the locked browse to ensure the locked browse is sized correctly in
 * order to allow vertical scrolling, and not cover the browse's horizontal scrollbar.
 * <br/>
 * This should be called any time the browse's vertical size changes, as well as the first
 * time it's displayed, if it was hidden when the page loaded.
 * @param browse - The browse object representing the browse to resize
 */
export function resizeLockedBrowseBodyForHorizontalScrollBar(browse: Browse)
{
    if (browse.unlockedBody?.length && browse.lockedBody?.length)
    {
        const unlockedBrowseBody = browse.unlockedBody;
        const lockedBrowseBody = browse.lockedBody;
        const lockedBrowseBodyWrapper = lockedBrowseBody.parent();
        if (hasHorizontalScrollBar(unlockedBrowseBody))
        {
            lockedBrowseBodyWrapper.css("bottom", `${scrollbarHeight}px`);
        }
        else
        {
            lockedBrowseBodyWrapper.css("bottom", "0px");
        }
    }
}

export function performGradebookCodeEELSearch(browseId: string, browseData: BrowseData, codeEELSearchText: string)
{
    const browse = getBrowseById(browseId);

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const data = getRequiredBrowseData(browse, browseData);
    $.extend(data, browseData);
    data.codeEELSearchText = encodeHtml(codeEELSearchText);

    return requestBrowse(browseId, browse, data, "GradebookCodeEELViewSearchResults");
}

export function performCodeEELSearch(browseId: string, browseData: PerformCodeEELSearchData, signal?: AbortSignal)
{
    const browse = getBrowseById(browseId);

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const data = getRequiredBrowseData(browse, browseData);
    data.codeEELSearchText = encodeHtml(browseData.codeEELSearchText);

    const selectTopRecord = data.seekId === undefined || typeof browseData.codeEELSearchText === "string";
    if (selectTopRecord)
    {
        data.seekId = -1;
        data.pagingType = "FirstPage";
    }

    return requestBrowse(browseId, browse, data, "PerformCodeEELSearch", signal);
}

export function performDistinctMultiSelectEELSearch(browseId: string, browseData: BrowseData, signal?: AbortSignal)
{
    const browse = getBrowseById(browseId);

    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    browse.displayName = browseData.isSingleSelect ? "Single Select EEL" : "Multi Select EEL";
    const data = getRequiredBrowseData(browse, browseData);
    data.distinctMultiSelectEELSearchText = browseData.distinctMultiSelectEELSearchText;
    data.isSingleSelect = browseData.isSingleSelect;
    data.allowMassSelect = browseData.allowMassSelect;

    return requestBrowse(browseId, browse, data, "PerformDistinctMultiSelectEELSearch", signal);
}

export function getSelectedRecordValue(browseId: string)
{
    const browse = getBrowseById(browseId);
    if (browse?.primaryKeys && browse.primaryKeys.length > browse.currentRow!)
    {
        return browse.primaryKeys[browse.currentRow!];
    }
    return null;
}

export function shouldIgnoreKeyboardEvent(node: Node | null)
{
    if (!node)
    {
        return false;
    }

    // Don't allow the browse to take over keyboard events for input elements
    return $(node).is("input:not(.eELInputContainer__textBox):not(.distinctMultiSelectUserInput):not(.accountDimensionEELCode), textarea, select, .tabListNavigator *");
}

export function setCurrentBrowseName(browseName: string)
{
    if (setCurrentOpenBrowse(browseName))
    {
        updateActiveBrowseClasses();
    }
}

export function getBrowseStats(browseName: string)
{
    return allBrowseStats[browseName];
}

export function getSql(browseName: string)
{
    const browse = getBrowseById(browseName);
    if (!browse)
    {
        return null;
    }
    if (!browse.cachedSql)
    {
        const data = getRequiredBrowseData(browse);
        browse.cachedSql = $.ajax(
            {
                url: `${virtualDir + browse.routeModule}/${browse.routeObject}/GetBrowseSQL`,
                // otherwise the activity indicator will trigger a mouseleave
                activityIndicator: { hideGlass: true },
                type: "POST",
                dataType: "JSON",
                data: data
            })
            .then(function (data: GetBrowseSqlResponse)
            {
                if (data.success && data.query)
                {
                    return data.query;
                }
                return "Unable to retrieve query.";
            });
    }
    return browse.cachedSql;
}

export function primaryButtonClick(
    browseName: string,
    rowNumber: number,
    target: string,
    module: string,
    object: string,
    screen: string,
    primaryKeyValue: string,
    mediaVerificationToken: string | null,
    data: Record<string, unknown>,
    event: JQuery.ClickEvent | null,
    allowClickActionForMobile: boolean)
{
    function doClick()
    {
        setCurrentRecord(browseName, rowNumber,
            {
                setCurrentBrowseName: true,
                loadRelatedBrowses: true
            });

        if (target === "" || module === "" || object === "" || screen === "")
        {
            return;
        }

        loadContent(target, module, object, screen, primaryKeyValue, data, null, undefined, null, false, null, null, mediaVerificationToken, null, null, undefined, button);
    }

    /* in mobile, detail links can now contain actionable elements. if one of these elements are clicked, cancel the detail click */
    if (mobileAccess && !allowClickActionForMobile && $(event?.target).closest("a[data-click-action]").length)
    {
        return;
    }

    const button = $(event?.target).closest(`.${classNames.button}`);
    if (button.length)
    {
        if (button.hasClass(classNames.uiDisabled))
        {
            return;
        }

        button.addClass(classNames.uiDisabled);

        setTimeout(function ()
        {
            button.removeClass(classNames.uiDisabled);
        }, 500);
    }

    skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
    {
        if (wasDirty)
        {
            setSkipUnloadCheck(true);
        }
        doClick();
    });
}

export function bindLockedBodySimulatedFocus(element: JQuery)
{
    const eventSelector = `.${classNames.unlockedBrowseBody} :focusable, .${classNames.unlockedHeader} :focusable`;
    element
        .off("focus", eventSelector, addSimulatedFocus).on("focus", eventSelector, addSimulatedFocus)
        .off("blur", eventSelector, removeSimulatedFocus).on("blur", eventSelector, removeSimulatedFocus);
}

export function browseLinkColumnPopup(module: string, object: string, action: string, headerText: string, data?: string)
{
    const jsonData = JSON.parse(data ?? "{}") as BrowseLinkColumnPopupData;

    const options = JSON.parse(jsonData["browse.options"] ?? "{}") as BrowseLinkColumnPopupOptions;
    options.draggable = true;

    const finalHeaderText = jsonData["browse.headertext"] ?? headerText;
    const button = jsonData["browse.button"]
        ? JSON.parse(jsonData["browse.button"]) as ButtonDefinition
        : null;

    const buttons: ButtonDefinition[] = [];

    if (button?.click)
    {
        try
        {
            const evalResult = window.eval(`"use strict";\n(${button.click})`) as unknown;
            button.click = (typeof evalResult === "function")
                ? (evalResult as JQuery.EventHandlerBase<HTMLElement, JQuery.ClickEvent>)
                : (() => {});
        }
        catch
        {
            button.click = () => {};
        }
        buttons.push(button);
    }

    const cancelButton =
    {
        id: "cancelButton",
        text: jsonData["browse.cancelButtonText"] ?? ButtonText.Cancel,
        icon: jsonData["browse.cancelButtonIcon"] ?? ButtonIcon.Cancel,
        click: () => { dialog.close("cancel"); }
    };

    buttons.push(cancelButton);

    const dialog = showDialog(finalHeaderText, buildPopup, buttons, options);

    if (jsonData.browseNameToTriggerResize)
    {
        addBrowseLoadResizeHandler(jsonData.browseNameToTriggerResize);
    }
    else
    {
        dialog.bodyPromise.done(function ()
        {
            dialog.content.find(`.${classNames.browse}`).each(function ()
            {
                addBrowseLoadResizeHandler(this.id);
            });
        });
    }

    function addBrowseLoadResizeHandler(browseName: string)
    {
        $(document.body).one(`browseLoaded.${browseName}`, function ()
        {
            const browse = $(`#${browseName}`);
            const browseBody = browse.find(`.${classNames.browseBody}`);
            const unlockedBrowseTable = browse.find(`.${classNames.unlockedBrowseTable}`);
            let height = unlockedBrowseTable.height();
            if (height === 0)
            {
                const noRecords = browse.find(`.${classNames.noRecordsInBrowse}`);
                if (noRecords.length > 0)
                {
                    height = noRecords.height();
                }
            }
            browseBody.css("max-height", "55vh");
            browseBody.css("height", height!);
            dialog.animateModalContents();
        });
    }

    function buildPopup()
    {
        return $.ajax(
        {
            url: `${virtualDir + module}/${object}/${action}?renderType=contentOnly`,
            type: "POST",
            dataType: "viewparthtml",
            data: jsonData
        });
    }
}

/**
 * Send a click to the browse row a DOM element belongs to.
 * This is helpful to trigger row changes from custom click-action buttons.
 * @param element the target element
 */
export function selectRowByElement(element: HTMLElement | JQuery)
{
    const browse = getContainingBrowse(element);
    const row = $(element).closest(`.${classNames.browseRow}`);
    if (!browse || row.length < 1)
    {
        return;
    }

    const rowNumber = row.find(`.${classNames.browseRowOptions}, .${classNames.browseDataCell}`).first().data("row") as number;
    setCurrentRecord(browse.id, rowNumber);
}

export function addBrowseScrollEvents(browse: Browse)
{
    const scrollEventParams =
    {
        unlockedBody: browse.unlockedBody,
        lockedBody: browse.lockedBody,
        unlockedHeader: browse.unlockedHeader,
        totals: browse.totals,
        scrollCallback: function ()
        {
            updateDropShadows(browse);
        }
    };

    addBrowseScrollEventsGeneric(scrollEventParams);
}

/**
 * Adds scroll events to the target browse bodies without the use of browseList objects
 * @param params Parameter object containing scroll event parameters
 * @param params.unlockedBody Unlocked Body of the browse
 * @param params.lockedBody Locked Body of the browse
 * @param params.unlockedHeader Unlocked Header of the browse
 * @param params.totals Object containing browse totals information (optional)
 * @param params.scrollCallback Callback for custom event handling (optional)
 */
export function addBrowseScrollEventsGeneric(params: BrowseScrollEventParams)
{
    attachScrollEvent(params.lockedBody!, params.unlockedBody!);
    attachScrollEvent(params.unlockedBody!, params.lockedBody!);

    function attachScrollEvent(scrollBody: JQuery, otherBody: JQuery)
    {
        scrollBody.on("scroll", scrollEventHandler);

        // Trigger the scroll event handler shortly after the user stops scrolling
        // to ensure we don't end the scrolling with the rows slightly ajar.
        scrollBody.debounce("scroll", scrollEventHandler, 50);

        function scrollEventHandler(this: HTMLElement, ...args: unknown[])
        {
            otherBody.prop("scrollTop", scrollBody[0].scrollTop);

            if (scrollBody === params.unlockedBody)
            {
                const scrollLeft = scrollBody[0].scrollLeft;
                params.unlockedHeader!.prop("scrollLeft", scrollLeft);
                if (params.totals)
                {
                    params.totals.container.prop("scrollLeft", scrollLeft);
                }
            }

            if (typeof params.scrollCallback === "function")
            {
                params.scrollCallback.apply(this, args);
            }
        }

    }
    attachTabEvent();

    // Attach a focusin event to the unlocked header to ensure that when a user tabs through the browse, the focused element is always visible in the unlocked body.
    function attachTabEvent() {
        if (params.unlockedHeader === undefined || params.unlockedBody === undefined) {
            return;
        }

        params.unlockedHeader.on("focusin", ":focusable", function ()
        {
            const focused = this as HTMLElement;
            const unlockedBody = params.unlockedBody!.get(0) as HTMLElement;

            const unlockedBodyRect = unlockedBody.getBoundingClientRect();
            const focusedRect = focused.getBoundingClientRect();

            const padding = 25;

            if (focusedRect.left < unlockedBodyRect.left + padding)
            {
                unlockedBody.scrollLeft -= Math.max(0, (unlockedBodyRect.left + padding) - focusedRect.left);
            }
            
            else if (focusedRect.right > unlockedBodyRect.right - padding)
            {
                unlockedBody.scrollLeft += focusedRect.right - (unlockedBodyRect.right - padding);
            }

            params.unlockedHeader!.prop("scrollLeft", unlockedBody.scrollLeft);
            if (params.totals && params.totals.container)
            {
                params.totals.container.prop("scrollLeft", unlockedBody.scrollLeft);
            }
        });
    }
}

export function prepMobileBrowseData(dataHtml: string)
{
    return $(dataHtml.replace(/width:/gi, "x:"));
}

export function applyMobileLockedColumn(container: JQuery, browseBody?: JQuery, unlockedBrowseBody?: JQuery)
{
    const containerDiv = $(container);
    if (!containerDiv.length)
    {
        return;
    }

    const localBrowseBody = browseBody ?? containerDiv.find(`.${classNames.browseBody}`);
    const localUnlockedBrowseBody = unlockedBrowseBody ?? containerDiv.find(`.${classNames.unlockedBrowseBody}`);
    let lockedColumnWidth: number | undefined;
    const containerId = containerDiv.attr("id");
    const mobileStyleTagId = `${containerId}_mobileBrowseStyles`;
    const useLockedHeaderAndFooter = localBrowseBody.is(":scrollable");
    const containerSelector = `#${containerId}.${mobileBrowseClasses.mobileBrowseContainer}`;
    const styles = [];

    $(document.head).find(`#${mobileStyleTagId}`).remove();
    localUnlockedBrowseBody.find(`.${mobileBrowseClasses.lockedColumnCell}`).removeClass(mobileBrowseClasses.lockedColumnCell);

    /* set the width and height on the first two cells of the table */
    localUnlockedBrowseBody.find<HTMLTableCellElement>("td:first-child").each(function ()
    {
        const cell = $(this);
        let cellId = this.id;

        if (!cellId)
        {
            cellId = `${this.parentElement?.id}_cell${this.cellIndex}`;
            this.id = cellId;
        }

        if (typeof lockedColumnWidth === "undefined")
        {
            lockedColumnWidth = cell.outerWidth();
        }

        const cellSelector = `${containerSelector} .${classNames.browseBody} #${CSS.escape(cellId)}`;

        const row = cell.closest("tr");
        const rowSelector = `${containerSelector} .${classNames.browseBody} #${CSS.escape(row[0].id)}`;
        styles.push(`${cellSelector}, ${cellSelector} td, ${rowSelector} {height:${row.outerHeight()}px;}`);

        cell.addClass(mobileBrowseClasses.lockedColumnCell);
    });

    /* set the widths on header cells */
    localUnlockedBrowseBody.children("table").children("thead").children("tr").children("td").each(function ()
    {
        const cell = $(this);
        // We use this to set CSS widths later, and since we are using box-sizing: border-box, we need to use a width measurement
        // that includes borders, such as offsetWidth, $.outerWidth(false), or computedStyle.width
        const width = this.offsetWidth;

        if (this.cellIndex === 0)
        {
            if (useLockedHeaderAndFooter)
            {
                const row = cell.closest("tr");
                const rowSelector = `${containerSelector} .${classNames.browseHeader} #${CSS.escape(row[0].id)}`;
                styles.push(`${rowSelector} {height:${row.outerHeight()}px;}`);

                cell.addClass(mobileBrowseClasses.lockedColumnCell);
                const headerSelector = `${containerSelector} .${classNames.unlockedHeader} td:nth-child(${this.cellIndex + 1})`;
                styles.push(`${headerSelector} {position: fixed;background-color: inherit;z-index: 1;height:${cell.parent().height()}px;}`);
                const footerSelector = `${containerSelector} .${classNames.browseBodyTotalsSectionLocked} td:nth-child(${this.cellIndex + 1})`;
                styles.push(`${footerSelector} {position: fixed;z-index: 1}`);
            }
        }
        else
        {
            styles.push(`${containerSelector} td:nth-child(${this.cellIndex + 1}) {width:${width}px;min-width:${width}px;}`);
        }
    });

    styles.push(`${containerSelector} td:nth-child(1) {width:${lockedColumnWidth}px;min-width:${lockedColumnWidth}px;}`);

    if (useLockedHeaderAndFooter)
    {
        containerDiv.find(`.${classNames.unlockedHeader} td:first-child`).addClass(mobileBrowseClasses.lockedColumnCell);
        const totalsSection = containerDiv.find(`.${classNames.browseBodyTotalsSectionLockedWrapper} .${classNames.browseBodyTotalsSection}`);
        if (totalsSection.length)
        {
            totalsSection.addClass(classNames.browseBodyTotalsSectionLocked);
            totalsSection.css("padding-bottom", `${totalsSection[0].getBoundingClientRect().height}px`);
        }
        styles.push(`${containerSelector} .${classNames.browseHeader} .${classNames.unlockedHeader} {margin-top:1px;right:${scrollbarHeight}px;}`);
    }
    else
    {
        containerDiv.find(`.${classNames.browseHeader}`).remove();
        containerDiv.find(`.${classNames.browseBodyTotalsSectionLockedWrapper}`).remove();
    }

    if (isIosApp)
    {
        // Mobile iOS doesn't redraw all the affected elements (namely, position: absolute) when a style is added to the head
        // We force a full page redraw to rectify this
        styles.push("body { transform: -webkit-transform: translate3d(0,0,0); transform: translate3d(0,0,0); }");
    }

    $(document.head).append($(`<style id="${mobileStyleTagId}" type="text/css">${styles.join("\n")}</style>`));
}

export function getDebugName(browse: Browse)
{
    let title = browse.displayName ?? "No Name Browse";

    if (browse.codeEelName !== undefined)
    {
        title += " EEL";
    }

    return `${title}: {${browse.skywardID ?? "Custom or On The Fly"}}`;
}

export function browseColumnSuperUserClick(this: HTMLElement | JQuery<HTMLElement>)
{
    const clickedElement = $(this);
    showDialog("Additional Information", "Field visibility is restricted to Super Users.", [DEFAULT_CLOSE_BUTTON], { anchorTo: clickedElement });
}

function bindBrowseCleanupEvents(browseName: string, thisBrowse: Browse, browseContainer: JQuery, isInDetailsPanel: boolean)
{
    if (isInDetailsPanel)
    {
        const detailsPanelEvents = skyward.detailsPanel.eventCallbacks as DetailsPanelEvents;

        // Since the details panel can be detached, we need to wait until the content is
        // totally cleared before removing browses from the browse list
        detailsPanelEvents.empty.registerCallback(callbackHandler);

        function callbackHandler()
        {
            removeBrowse(browseName);
            detailsPanelEvents.empty.deregisterCallback(callbackHandler);
        }
    }
    else
    {
        // Remove browses from the browseList when the container is removed from the DOM
        skyward.window.registerDOMUnloadCallback(browseContainer)
            ?.then(cleanupBrowseListWhenBrowseRemoved)
            .catch(() => { });
        // When window.loadContent replaces content, the DOMUnloadCallback is called too late.
        // Add a handler here to ensure the browse data is cleaned up before the content is changed, not after.
        $(document.body).on("DOMInsertionPreLoad", browseWillBeRemovedHandler);
    }

    function browseWillBeRemovedHandler(eventData: JQuery.TriggeredEvent)
    {
        const target = eventData.target as HTMLElement | null;
        const containerElement = browseContainer.get(0);
        if (target && containerElement && target.contains(containerElement))
        {
            cleanupBrowseListWhenBrowseRemoved();
        }
    }

    function cleanupBrowseListWhenBrowseRemoved()
    {
        if (getBrowseById(browseName) === thisBrowse)
        {
            removeBrowse(browseName);
        }
        skyward.window.removeDOMUnloadCallback(browseContainer);
        $(document.body).off("DOMInsertionPreLoad", browseWillBeRemovedHandler);
    }
}

function addSimulatedFocus(this: HTMLElement)
{
    $(`#${this.id}_lockedMirror`).addClass(classNames.simulateFocus);
    selectRowByElement(this);
}

function removeSimulatedFocus(this: HTMLElement)
{
    $(`#${this.id}_lockedMirror`).removeClass(classNames.simulateFocus);
}

// ChangeRow() is called only by keyDown, which is called for the initial keydown and all repeats.  A different method, rowChange(),
// is called on keyUp, only when the key is finally released.  This method should include only things that can't wait, like changing
// the visible current row and showing the dirty details panel warning.  Everything else, like changing the details panel and related
// browses, should be handled in keyUp.
function changeRow(browseName: string, browse: Browse, rowNumber: number)
{
    if (getCurrentBrowseName() !== browseName)
    {
        setCurrentBrowseName(browseName);
    }
    else if (browse.currentRow === rowNumber)
    {
        return;
    }

    browseDetailsPanel.tryRowChange(browseName, doChangeRow, false);

    function doChangeRow()
    {
        setCurrentRecord(browseName, rowNumber,
            {
                loadRelatedBrowses: false,
                setCurrentBrowseName: true,
                updateBrowseSeekInfo: false
            });
    }
}

function getSearchTextValue(browseName: string)
{
    const browse = getBrowseById(browseName);
    if (!browse)
    {
        return "";
    }

    const control = browse.seek;
    const searchContainer = browse.searchContainer;
    if (!control || !searchContainer || control.hasClass(classNames.noSearchAvailable))
    {
        return "";
    }

    const fieldType = searchContainer.data("fieldType") as string;

    let searchText: string;
    switch (fieldType)
    {
        case "date":
            const date = getValue(control) as unknown;
            if (!(date instanceof Date) || !validDate(date))
            {
                return;
            }
            searchText = date.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: '2-digit'
            });
            break;
        case "number":
            searchText = getValue(control) as string;
            if (!validNumber(searchText))
            {
                return;
            }
            break;
        default:
            searchText = getValue(control) as string;
    }

    return searchText;
}

function browseLoadedSuccess(browse: Browse, data: BrowseData, localStopwatch: Stopwatch, totalStopwatch: Stopwatch, downloadTime: number, doRequest: () => void)
{
    const browseStats = {} as BrowseStats;
    browseStats["Server Response"] = downloadTime;
    browseStats["DOM Insertion"] = localStopwatch.duration();
    localStopwatch.restart();

    let script = data.script as string;
    const urlInText = /\n\/\/# (sourceMappingURL|sourceURL)[^\n]*\n?$/.test(script);
    if (!urlInText)
    {
        script += `\n//# sourceURL=registerBrowse_${browse.id}_eval.js`;
    }

    // since the root element of the browse isn't replaced when refreshing, if there are any events on the browse element itself we need to reset in order to re-run them
    reapplyLoadActionClasses($(`#${browse.id}`));
    eval(script);
    notifyDOMLoad(`#${browse.id}`);

    browseStats["Script Execution"] = localStopwatch.duration();
    browseStats.Total = totalStopwatch.duration();

    allBrowseStats[browse.id] = browseStats;

    if (browseDetailsPanel.currentDetailsBrowse === browse.id && ($(`#${browse.id} .${classNames.browseRow}.${classNames.noRecordsInBrowse}`).length || browse.body?.find(`.${classNames.cmaErrorMessage}`).length))
    {
        browseDetailsPanel.hideDetailsPanel(false);
    }

    //ensure related browses clear if their parent has no records
    if (browse.currentRow == null && browse.relatedBrowses)
    {
        $.each(browse.relatedBrowses, function (_, browseValue)
        {
            getRelatedBrowse(browseValue.BrowseID);
        });
    }

    if (browse.refreshTimeout !== -1)
    {
        if (refreshTimeout !== null)
        {
            clearTimeout(refreshTimeout);
        }
        browse.timestamp = 0;
        refreshTimeout = window.setTimeout(doRequest, browse.refreshTimeout);
    }
}

function browseResize(browseName: string)
{
    const thisBrowse = getBrowseById(browseName);

    if (!thisBrowse)
    {
        return;
    }

    const browse = thisBrowse.browse;
    const lockedBody = thisBrowse.lockedBody ?? $();
    const unlockedBody = thisBrowse.unlockedBody ?? $();

    const unlockedHeader = thisBrowse.unlockedHeader ?? $();
    const lockedHeader = thisBrowse.lockedHeader ?? $();

    const baseErrorDiv = thisBrowse.baseErrorDiv ?? $();
    let index;

    if (baseErrorDiv.length > 0)
    {
        let contentMessageAreaHeight = 0;
        const contentMessageArea = getContentMessageArea($(`#${thisBrowse.id}`).parent());
        const contentMessageAreaElement = contentMessageArea?.getContentMessageAreaElement();
        if (contentMessageAreaElement !== undefined)
        {
            contentMessageAreaHeight = contentMessageAreaElement.height()!;
        }
        const outerHeight = baseErrorDiv.outerHeight(true) ?? 0;
        const totalHeight = outerHeight + contentMessageAreaHeight;
        browse?.css({
            "top": `${totalHeight}px`
        }); // Handle editable browse in details when we have errors/warnings
    }

    lockedHeader.height(unlockedHeader.height()!);

    thisBrowse.resize = function ()
    {
        browseResize(browseName);
    };

    resizeLockedBrowseBodyForHorizontalScrollBar(thisBrowse);
    if (thisBrowse.totals?.container.length)
    {
        thisBrowse.totals.container.find(`.${classNames.browseBodyTotalScrollbarFiller}`).css("width", `${scrollbarHeight}px`);
    }

    const lockedRows = lockedBody.find(`.${classNames.browseRow}`);
    if (lockedRows.length > 0)
    {
        // Used to batch up height reads and writes so we don't have to recalculate styles for the whole browse after every row
        const heights = [];
        const unlockedRows = unlockedBody.find(`.${classNames.browseRow}`);
        for (index = 0; index < unlockedRows.length; index++)
        {
            const unlockedRow = unlockedRows[index];
            const lockedRow = lockedRows[index] as HTMLElement | undefined;
            if (lockedRow)
            {
                // This allows rows to get bigger but not smaller until the next browse load. The performance cost of allowing rows to shrink if they need to is very high.
                const unlockedHeight = unlockedRow.getBoundingClientRect().height;
                const lockedHeight = lockedRow.getBoundingClientRect().height;
                if (unlockedHeight !== lockedHeight)
                {
                    // This assumes that both the locked and unlocked columns have boxSizing: border-box and identical border sizes, so offsetHeight can
                    // be passed straight to .css().
                    // We can't use jQuery's .height() because it reads boxSizing and recomputes the height, which would force a style recalculation and
                    // prevent any speedup.
                    heights.push(unlockedHeight > lockedHeight ? { height: unlockedHeight, elem: lockedRow } : { height: lockedHeight, elem: unlockedRow });
                }
            }
            else
            {
                break;
            }
        }

        for (const item of heights)
        {
            $(item.elem).css("height", `${item.height}px`);
        }
    }

    browse?.trigger(`browseResize.${browseName}`);
}

function getRelatedBrowses(browse: Browse)
{
    const deferred: (JQuery.Promise<unknown> | Promise<unknown>)[] = [];

    $.each(browse.relatedBrowses, function (_browseKey, browseValue: RelatedBrowse)
    {
        const promise = getRelatedBrowse(browseValue.BrowseID);
        deferred.push(promise);
    });

    return $.when.apply($, deferred);
}

function getCurrentRecordTargetId(browseName: string)
{
    const browse = getBrowseById(browseName);
    if (!browse)
    {
        return null;
    }

    const row = getUnlockedRowElement(browse);
    if (row.length === 0)
    {
        return null;
    }

    return row.data("targetid") as number;
}

function noColumnsInsertColumnButtonClick(this: HTMLElement | JQuery)
{
    const insertColumnButton = $(this);
    const browse = getContainingBrowse(insertColumnButton)!;
    popInsertColumnView(browse, -1, insertColumnButton);
}

/**
 * Display appropriate drop shadows for the browse's current Y scroll position.
 * @param thisBrowse - The browse object to update (from browseList)
 */
function updateDropShadows(thisBrowse: Browse)
{
    const hadShadow = thisBrowse.hasShadow ?? false;
    const hasShadow = thisBrowse.unlockedBody?.scrollLeft() !== 0;
    if (hasShadow !== hadShadow)
    {
        thisBrowse.lockedBody?.toggleClass(classNames.lockedBrowseShadow, hasShadow);
        thisBrowse.lockedHeader?.toggleClass(classNames.lockedBrowseShadow, hasShadow);
        if (thisBrowse.totals)
        {
            thisBrowse.totals.container.toggleClass(classNames.lockedBrowseShadow, hasShadow);
        }
    }
    thisBrowse.hasShadow = hasShadow;
}

function updateActiveBrowseClasses()
{
    let activeLayer = $(`.${classNames.modalLayerContainer}`).last();

    if (activeLayer.length === 0)
    {
        activeLayer = $("#master");
    }

    const browsesInActiveLayer: JQuery[] = [];
    activeLayer.find(`.${classNames.browse}`).each(function ()
    {
        browsesInActiveLayer.push($(this));
    });

    const currentActiveBrowseInLayer = activeLayer.find(`.${classNames.mainSelectedBrowse}`);
    const newActiveBrowseInLayer = findActiveBrowseInLayer(browsesInActiveLayer);

    if (currentActiveBrowseInLayer.length === 0 || currentActiveBrowseInLayer.attr("id") !== newActiveBrowseInLayer?.attr("id"))
    {
        currentActiveBrowseInLayer.removeClass(classNames.mainSelectedBrowse);
        if (newActiveBrowseInLayer)
        {
            newActiveBrowseInLayer.addClass(classNames.mainSelectedBrowse);
        }
        eventCallbacksInternal.updateActiveBrowseClasses.dispatchCallbacks();
    }
}

function findActiveBrowseInLayer(layerBrowses: JQuery[])
{
    if (layerBrowses.length > 0)
    {
        const firstBrowseId = layerBrowses[0].attr("id")!;
        let latestPositionInList = indexOfOpenBrowse(firstBrowseId);

        let toReturn = layerBrowses[0];
        for (let i = 1; i < layerBrowses.length; i++)
        {
            const id = layerBrowses[i].attr("id")!;
            const positionInList = indexOfOpenBrowse(id);
            if (positionInList > latestPositionInList)
            {
                latestPositionInList = positionInList;
                toReturn = layerBrowses[i];
            }
        }

        return toReturn;
    }

    return null;
}

function deselectPreviousRecord(browseName: string)
{
    const browse = getBrowseById(browseName);
    if (!browse)
    {
        return;
    }

    getRowElements(browse).removeClass(classNames.current).attr("aria-selected", null);
}

function isDeselectPreviousRecordOverridden(browseName: string)
{
    const deselectPreviousRecordOverride = deselectPreviousRecordOverrides[browseName];
    return deselectPreviousRecordOverride !== undefined && !deselectPreviousRecordOverride(browseName);
}

function getIdentityFieldValuesBasedOnType(pagingType: string, browse: Browse)
{
    if (pagingType === "FollowingPage")
    {
        return browse.lastRowIdentityFieldValues;
    }
    else if (pagingType === "PrecedingPage")
    {
        return browse.firstRowIdentityFieldValues;
    }

    return null;
}

function browseHeaderColumnClick(this: HTMLElement | JQuery<HTMLElement>)
{
    const clickedElement = $(this);
    const browseData = clickedElement.data() as BrowseColumnData | undefined;
    if (browseData == null)
    {
        return;
    }

    const browse = getContainingBrowse(this);
    if (!browse)
    {
        return;
    }

    const columnViewIndex = browseData.columnViewIndex;

    const data = getRequiredBrowseData(browse, browseData);
    data.seekId = -1;

    const popupData: ColumnHeaderPopupData =
    {
        browseName: browse.browseName,
        routeModule: browse.routeModule,
        routeObject: browse.routeObject,
        dataModule: browse.dataModule,
        dataObject: browse.dataObject,
        pageModule: browse.pageModule,
        pageObject: browse.pageObject,
        pageScreen: browse.pageScreen,
        taskName: browse.taskName,
        routeHash: browse.routeHash,
        columnViewIndex: columnViewIndex,
        fieldName: browseData.sortField,
        browseSearchCondition: browse.browseSearchCondition,
        browseSearchConditionHash: browse.browseSearchConditionHash,
        userSearchCondition: browse.userSearchCondition,
        userSearchConditionHash: browse.userSearchConditionHash,
        preventColumnSort: browse.preventColumnSort,
        preventColumnResize: browse.preventColumnResize,
        renderFilterOptions: !browse.isCodeEel && browse.renderFilterButton
    };

    let url: string;
    let dialogTitle: string;
    if (browse.data?.browseViewEditorHash)
    {
        url = `${virtualDir}Skysys/Filter/BuildColumnFilterViewpartForBrowseViewEditor/`;
        popupData.postData = JSON.stringify(browse.data);
        dialogTitle = "Options";
    }
    else
    {
        url = `${virtualDir}skysys/filter/buildcolumnfilterviewpart/`;
        popupData.browseTempTableName = browse.tempTableName;
        dialogTitle = "Column Options";
    }

    const gearIcon = clickedElement.find(`.${classNames.svg}.${classNames.settingsIcon}.${classNames.svgBrowseColumnHeader}`);

    const saveButton =
    {
        id: "saveColumnFilter",
        text: ButtonText.Save,
        icon: ButtonIcon.Save,
        click: () => { saveColumn(browse.id, browse, data, browseData.sortField, dialog); }
    };

    const cancelButton =
    {
        id: "cancelColumnFilter",
        text: ButtonText.Cancel,
        icon: ButtonIcon.Cancel,
        click: () => { dialog.close("cancel"); }
    };

    const options =
    {
        afterClose: () => { gearIcon.css("visibility", ""); },
        anchorTo: mobileAccess ? null : clickedElement,
        id: "BrowseColumnOptionsModal"
    };

    const dialog = showDialog(dialogTitle, buildPopup, [saveButton, cancelButton], options);
    gearIcon.css("visibility", "visible");

    dialog.content.on("contentLoaded", function ()
    {
        dialog.content.find(`.${classNames.insertColumnButton}`).on("click", function ()
        {
            dialog.close();
            popInsertColumnView(browse, columnViewIndex, clickedElement);
        });

        dialog.content.find(`.${classNames.deleteColumnButton}`).on("click", function ()
        {
            dialog.close();
            deleteColumn(browse, browseData.sortField, columnViewIndex);
        });
    });

    function buildPopup()
    {
        // The browse request data carries the row data and hashes the server needs to validate this request and
        // resolve the query parameter bindings. popupData wins on the keys they share.
        return $.ajax(
        {
            url: url,
            type: "POST",
            dataType: "viewparthtml",
            activityIndicator: { hideGlass: true },
            data: $.extend({}, data, popupData)
        });
    }
}

function saveColumn(browseId: string, browse: Browse, data: Record<string, unknown>, field: string, dialog: ModalDialog)
{
    saveColumnData(browse).then(function (result)
    {
        if (result.success)
        {
            saveColumnFilter(browseId, browse, data, field);
            dialog.close();
        }
        else
        {
            displayValidationMessages(result, "BrowseColumnOptions", $("#BrowseViewColumnOptionsBaseErrors"));
        }
    });
}

function saveColumnData(browse: Browse)
{
    const headerText = $("#BrowseColumnOptions_HeaderText").val() as string;
    const width = $("#BrowseColumnOptions_Width").val() as number;
    const columnIndex = $("#BrowseColumnOptions_ColumnIndex").val() as number;
    const locked = $("#BrowseColumnOptions_Locked").is(":checked");
    const wrapData = $("#BrowseColumnOptions_WrapData").is(":checked");
    const columnViewIndex = $("#BrowseColumnOptions_ColumnViewIndex").val() as number;
    const visibilityRestrictedToSuperUsers = getValue($("#BrowseColumnOptions_SuperUserVisibility")) as boolean;

    const data: ColumnSaveData =
    {
        headerText: headerText,
        width: width,
        columnIndex: columnIndex,
        locked: locked,
        wrapData: wrapData,
        columnViewIndex: columnViewIndex,
        visibilityRestrictedToSuperUsers: visibilityRestrictedToSuperUsers
    };

    let url: string;

    if (browse.data?.browseViewEditorHash)
    {
        url = `${virtualDir}Skysys/BrowseView/UpdateBrowseViewEditorBrowseColumn/`;
        data.postData = JSON.stringify(browse.data);
    }
    else
    {
        url = `${virtualDir}Skysys/BrowseView/UpdateBrowseColumn/`;
        data.pageModule = browse.pageModule;
        data.pageObject = browse.pageObject;
        data.pageScreen = browse.pageScreen;
        data.pageTab = browse.pageTab;
        data.browseName = browse.browseName;
        data.taskName = browse.taskName;
    }

    return $.ajax(
    {
        url: url,
        type: "POST",
        dataType: "JSON",
        activityIndicator: { hideGlass: true },
        data: data
    });
}

function saveColumnFilter(browseId: string, browse: Browse, data: Record<string, unknown>, field: string)
{
    const sortDirection = getValue($(`.${classNames.saveColumnFilterSort}`)) as string;
    const boolFilterValue = getValue($(`.${classNames.saveBoolFilterSort}`)) as string;
    const dataType = $("#filterSection").data("data-type") as string;
    const filterData = {} as Row;
    const sortData = sortDirection === "null" ? null : sortDirection === "descending";

    let filterType;
    if (boolFilterValue.length)
    {
        filterType = "bool";

        filterData.TrueOnly = boolFilterValue === "trueOnly"
            ? true
            : (boolFilterValue === "falseOnly" ? false : null);

        filterData.FilterType = (filterData.TrueOnly !== null) ? "selection" : "none";
    }
    else
    {
        filterType = (dataType === "Enumeration")
            ? "selection"
            : getValue($("#rangeOrSelect")) as string;

        filterData.FilterType = filterType;
    }

    if (filterType === "range")
    {
        const rangeLowElement = $("#txtLowRange");
        const rangeHighElement = $("#txtHighRange");

        filterData.RangeLow = getValue(rangeLowElement) as string;
        filterData.RangeHigh = getValue(rangeHighElement) as string;

        if (isDate(filterData.RangeLow, false))
        {
            filterData.RangeLow = formatServerDate(filterData.RangeLow);
        }
        if (isDate(filterData.RangeHigh, false))
        {
            filterData.RangeHigh = formatServerDate(filterData.RangeHigh);
        }
    }
    else if (filterType === "selection")
    {
        const dmsElement = $(`#selectFilterSection .${classNames.dmsBackingData}`);
        const dmsData = getValue(dmsElement) as Row[];
        filterData.DmsJson = JSON.stringify(dmsData).replaceAll(new RegExp(/(\\+r\\+n)/, "g"), "\\r\\n");
    }

    const filter: Record<string, Row> = {};
    filter[field] = filterData;
    data.filter = JSON.stringify(filter);

    const sort: Record<string, boolean | null> = {};
    sort[field] = sortData;
    data.sort = JSON.stringify(sort);

    let action;
    if (browse.data?.browseViewEditorHash)
    {
        action = "UpdateBrowseViewEditorView";
        data.postData = JSON.stringify(browse.data);

        const originalSortDirection = getOriginalValue($(`.${classNames.saveColumnFilterSort}`)) as string;
        if (originalSortDirection !== sortDirection)
        {
            data.browseViewSortChange = true;
        }
    }
    else
    {
        action = "UpdateFilterAndView";
    }

    return requestBrowse(browseId, browse, data, action);
}

function performSearch(browseId: string, browseData: BrowseData)
{
    const browse = getBrowseById(browseId);
    if (!browse)
    {
        return;
    }

    const data = getRequiredBrowseData(browse, browseData);
    data.seekId = -1;

    return requestBrowse(browseId, browse, data, "PerformBrowseSearch");
}

function initActiveBrowseClass(selector: string)
{
    if ($(selector).hasClass(classNames.browse))
    {
        updateActiveBrowseClasses();
    }
}

function initSortableColumns(selector: string)
{
    $(selector).find(`.${classNames.allowColumnSort}`).each(function ()
    {
        const header = $(this);
        const sortableItems = header.find(`.${classNames.browseHeaderDraggable}`);

        if (sortableItems.length <= 1)
        {
            return;
        }

        const browseHeaderContainer = header.closest(`.${classNames.browseHeader}`);
        const browseBodyContainer = browseHeaderContainer.siblings(`.${classNames.browseBody}`);
        const lockedBrowseBody = browseBodyContainer.find(`.${classNames.lockedBrowseBody}`);
        const unlockedBrowseBody = browseBodyContainer.find(`.${classNames.unlockedBrowseBody}`);

        const locked = header.hasClass(classNames.lockedHeaderTableRow);

        const unlockedHeader = locked
            ? browseHeaderContainer.find(`.${classNames.unlockedHeaderTableRow}`)
            : header;

        const fieldIndexToColumns: Record<string, FieldIndex> = {};

        for (let siIndex = 0; siIndex < sortableItems.length; siIndex++)
        {
            const currentFieldIndex = ($(sortableItems[siIndex]).data() as SortableColumnData).columnIndex;
            const fieldIndexSelector = `[data-column-index='${currentFieldIndex}']`;
            const groupedItems = sortableItems.filter(fieldIndexSelector);
            const itemsToWrap = sortableItems.filter(fieldIndexSelector);

            const startingIndex = (itemsToWrap.first().data() as SortableColumnData).columnIndex;
            const endingIndex = (itemsToWrap.last().data() as SortableColumnData).columnIndex;

            fieldIndexToColumns[currentFieldIndex] =
            {
                startingIndex: startingIndex,
                endingIndex: endingIndex
            };

            // Wrap Group Columns in td to allow them to sort together
            if (groupedItems.length > 1)
            {
                const wrapper = $("<td/>",
                    {
                        class: "browseHeaderDraggable groupColumnWrapper",
                        data:
                        {
                            fieldName: groupedItems[0].dataset.groupColumnName,
                            columnIndex: currentFieldIndex,
                            groupColumn: true,
                            numberOfColumns: itemsToWrap.length
                        }
                    });

                itemsToWrap.replaceTagNames("div");
                itemsToWrap.wrapAll(wrapper);
                siIndex += groupedItems.length - 1;
            }
        }

        header.sortable(
            {
                axis: "x",
                opacity: 0.7,
                distance: 15,
                scroll: false,
                forcePlaceholderSize: true,
                items: `> .${classNames.browseHeaderDraggable}`,
                cancel: `.${classNames.browseColumnFilterMenuLaunch}`,
                helper: function (_event, element)
                {
                    const helper = $(element).clone();
                    const iconContainer = helper.find(`.${classNames.iconContainerDiv}`);
                    if (iconContainer.length)
                    {
                        iconContainer.children().remove();
                    }
                    return helper as unknown as Element;
                },
                placeholder: "browseHeaderColumn browseColumnSortablePlaceHolder",
                start: function (event, ui)
                {
                    header.sortable("refreshPositions");
                    startBodyPlaceholder(event, ui);
                },
                update: function (_event, ui)
                {
                    header.sortable("option", "disabled", true);

                    const currentColumn = ui.item;
                    const newPrecedingColumn = ui.item.prev();

                    const currentColumnData = currentColumn.data() as Partial<SortableColumnData>;
                    const newPrecedingColumnData = newPrecedingColumn.data() as Partial<SortableColumnData>;

                    const currentColumnIndex = currentColumnData.columnIndex!;
                    const newPrecedingColumnIndex = newPrecedingColumnData.columnIndex ?? null;

                    const currentFieldName = currentColumnData.fieldName;
                    const newPrecedingFieldName = newPrecedingColumnData.fieldName ?? null;

                    const browseId = header.data("browseId") as string;
                    const browse = getBrowseById(browseId)!;

                    browse.columnFieldNames ??= [];
                    const columnFieldName = browse.columnFieldNames.splice(currentColumnIndex, 1)[0];
                    let spliceIndex = newPrecedingColumnIndex ?? -1;
                    if (spliceIndex < currentColumnIndex)
                    {
                        spliceIndex += 1;
                    }
                    browse.columnFieldNames.splice(spliceIndex, 0, columnFieldName);

                    if (browse.totals?.container.length)
                    {
                        moveTotalColumns();
                    }

                    const browseData = header.closest(`.${classNames.browse}`).data();
                    const data = getRequiredBrowseData(browse, browseData);

                    let action = "ChangeBrowseColumnOrder";

                    if (browse.data?.browseViewEditorHash)
                    {
                        data.postdata = browse.data;
                        action = "ChangeBrowseViewEditorColumnOrder";
                    }

                    data.currentColumnIndex = currentColumnIndex;
                    data.newPrecedingColumnIndex = newPrecedingColumnIndex;

                    data.currentFieldName = currentFieldName;
                    data.newPrecedingFieldName = newPrecedingFieldName;

                    requestBrowse(browseId, browse, data, action);

                    function moveTotalColumns()
                    {
                        const container = browse.totals!.container;

                        const currentTotalColumn = container.find(`.${classNames.browseBodyTotalColumn}[data-column='${currentColumnIndex}']`);

                        const newPrecedingTotalColumn = (newPrecedingColumnIndex !== null)
                            ? container.find(`.${classNames.browseBodyTotalColumn}[data-column='${newPrecedingColumnIndex}']`)
                            : container.find(`.${classNames.browseBodyTotalButtonsFiller}`);

                        newPrecedingTotalColumn.after(currentTotalColumn);

                        if (currentTotalColumn.hasClass(classNames.browseBodyLockedTotalColumn))
                        {
                            // clear shadow column in case the moved column was the rightmost locked column, or has taken its place
                            currentTotalColumn.add(newPrecedingTotalColumn).removeClass(classNames.browseBodyShadowColumn);
                            container.find(`.${classNames.browseBodyLockedTotalColumn}`).last().addClass(classNames.browseBodyShadowColumn);
                        }
                        else
                        {
                            // clear margin-left in case the moved column was the leftmost unlocked column, or has taken its place
                            // (updateTotalColumnOffsets will set it again on the appropriate column)
                            currentTotalColumn.add(currentTotalColumn.next()).css("margin-left", "");
                        }
                        const totalColumns = container.find(`.${classNames.browseBodyTotalColumn}, .${classNames.browseBodyTotalButtonsFiller}`);
                        updateTotalColumnOffsets(totalColumns, 0);
                    }
                },
                change: function (event, ui)
                {
                    changeBodyPlaceholder(event, ui);
                },
                stop: function ()
                {
                    stopBodyPlaceholder();
                }
            });

        // Handle scrolling while sorting in unlocked body
        if (!locked)
        {
            const scrollableBody = header.closest(`.${classNames.browse}`).find(`.${classNames.unlockedBrowseBody}`);
            const headerContainer = header.closest(`.${classNames.unlockedHeader}`);
            const lockedHeader = headerContainer.siblings(`.${classNames.lockedHeader}`);
            let lockedHeaderWidth = 0;
            if (lockedHeader.length > 0)
            {
                lockedHeaderWidth = lockedHeader.width()!;
            }
            let isScrolling = false;
            let scrollingId: number;

            header.on("sort", checkScroll);

            function checkScroll(event: JQuery.TriggeredEvent)
            {
                if (headerContainer.length === 0)
                {
                    return;
                }
                const e = (event as JQuery.MouseEventBase).originalEvent!;
                const left = headerContainer.offset()!.left + lockedHeaderWidth;
                const right = left + headerContainer.width()! - lockedHeaderWidth;
                let distance = 0;
                let multiplier = 1;
                const padding = 25;

                if (e.pageX < (left + padding) && e.pageX > (left - padding))
                {
                    distance = left - (e.pageX - padding);
                    multiplier = -1;
                }
                else if (e.pageX < (right + padding) && e.pageX > (right - padding))
                {
                    distance = e.pageX - (right - padding);
                    multiplier = 1;
                }

                if (distance !== 0)
                {
                    const acceleration = 1.75;
                    const accelerationLimiter = 0.1;
                    isScrolling = true;
                    clearTimeout(scrollingId);
                    scroll(Math.pow(Math.abs(distance), acceleration) * accelerationLimiter * multiplier);
                }
                else
                {
                    isScrolling = false;
                }
            }

            function scroll(amount: number)
            {
                if (isScrolling)
                {
                    scrollableBody.scrollLeft(scrollableBody.scrollLeft()! + amount);
                    scrollingId = window.setTimeout(function ()
                    {
                        scroll(amount);
                    }, 10);
                }
            }

            // Handle scrolling while tabbing through columns in unlocked body
            header.on("focusin", (e: JQuery.FocusInEvent) =>
            {
                const unlockedBody = header.closest(`.${classNames.browse}`).find(`.${classNames.unlockedBrowseBody}`);
                const headerContainer = header.closest(`.${classNames.unlockedHeader}`);
                const lockedHeader = headerContainer.siblings(`.${classNames.lockedHeader}`);

                window.setTimeout(() =>
                {
                    const focused = $(e.target).parent().parent().get(0);
                    if (focused == undefined)
                    {
                        return;
                    }

                    const unlockedBodyContainer = unlockedBody.get(0) as HTMLElement;
                    const lockedBodyContainer = lockedHeader.get(0) as HTMLElement;

                    if (!unlockedBodyContainer || !lockedBodyContainer)
                    {
                        return;
                    }

                    const unlockedBodyRect = unlockedBodyContainer.getBoundingClientRect();
                    const focusedRect = focused.getBoundingClientRect();
                    const padding = 8;

                    const focusedLeftInContent = Math.round(unlockedBodyContainer.scrollLeft + (focusedRect.left - unlockedBodyRect.left));
                    const focusedRightInContent = focusedLeftInContent + Math.round(focusedRect.width);

                    const maxScroll = Math.max(0, unlockedBodyContainer.scrollWidth - unlockedBodyContainer.clientWidth);
                    const lockedWidth = lockedHeader && lockedHeader.length ? Math.round((lockedHeader[0]).getBoundingClientRect().width) : 0;

                    let scrollLeftDistance = unlockedBodyContainer.scrollLeft;

                    if (focusedLeftInContent < unlockedBodyContainer.scrollLeft + lockedWidth + padding)
                    {
                        scrollLeftDistance = Math.max(0, Math.round(focusedLeftInContent - lockedWidth - padding));
                    }
                    else if (focusedRightInContent > unlockedBodyContainer.scrollLeft + unlockedBodyContainer.clientWidth - padding)
                    {
                        scrollLeftDistance = Math.min(maxScroll, Math.round(focusedRightInContent - (unlockedBodyContainer.clientWidth - padding)));
                    }

                    if (Math.abs(scrollLeftDistance - unlockedBodyContainer.scrollLeft) >= 1)
                    {
                        unlockedBodyContainer.scrollLeft = scrollLeftDistance;
                        headerContainer?.prop("scrollLeft", scrollLeftDistance);
                        lockedHeader?.prop("scrollLeft", scrollLeftDistance);
                    }
                }, 0);
            });
        }

        function removeBodyPlaceholder(body: JQuery)
        {
            body.find(`.${classNames.browseBodySortablePlaceholder}`).remove();
        }

        function buildColumnSelector(fieldIndexToColumn: FieldIndex)
        {
            const dataSelectors = [];
            for (let i = fieldIndexToColumn.startingIndex; i <= fieldIndexToColumn.endingIndex; i++)
            {
                dataSelectors.push(`.browseDataCell[data-column='${i}']`);
            }
            return dataSelectors.join(", ");
        }

        function getCellsByFieldIndex(fieldIndex: number, body: JQuery)
        {
            const rows = body.find(`.${classNames.browseRow}`);
            const columns = fieldIndexToColumns[fieldIndex];
            const cells = rows.find(buildColumnSelector(columns));
            return cells;
        }

        function hideColumn(fieldIndex: number, body: JQuery)
        {
            const cells = getCellsByFieldIndex(fieldIndex, body);
            cells.addClass(classNames.columnDragging);
        }

        function insertBodyPlaceholder(fieldIndex: number, body: JQuery, ui: JQueryUI.SortableUIParams, insertAfter: boolean)
        {
            const columns = fieldIndexToColumns[fieldIndex];
            const placeholder = ui.placeholder.clone().addClass(classNames.browseBodySortablePlaceholder);
            body.find(`.${classNames.browseRow}`).each(function ()
            {
                const cells = $(this).find(`.${classNames.browseDataCell}[data-column='${columns.endingIndex}']`);

                if (insertAfter)
                {
                    cells.last().after(placeholder.clone());
                }
                else
                {
                    cells.first().before(placeholder.clone());
                }
            });
        }

        function removeUnlockedHeaderPlaceholder()
        {
            unlockedHeader.find(`.${classNames.browseHeaderDraggablePlaceholder}`).remove();
        }

        function insertUnlockedHeaderPlaceholder(fieldIndex: number, ui: JQueryUI.SortableUIParams, insertAfter: boolean)
        {
            const sibling = unlockedHeader.find(`[data-field-index='${fieldIndex}']`);

            if (insertAfter)
            {
                sibling.after(ui.placeholder.clone().addClass(classNames.browseHeaderDraggablePlaceholder));
            }
            else
            {
                sibling.before(ui.placeholder.clone().addClass(classNames.browseHeaderDraggablePlaceholder));
            }
        }

        function hideUnlockedHeaderColumn(fieldIndex: number)
        {
            unlockedHeader.find(`[data-field-index='${fieldIndex}']`).addClass(classNames.columnDragging);
        }

        function startBodyPlaceholder(_event: unknown, ui: JQueryUI.SortableUIParams)
        {
            const columnFieldIndex = (ui.item.data() as SortableColumnData).columnIndex;

            if (locked)
            {
                hideColumn(columnFieldIndex, lockedBrowseBody);
                insertBodyPlaceholder(columnFieldIndex, lockedBrowseBody, ui, true);
                hideUnlockedHeaderColumn(columnFieldIndex);
                insertUnlockedHeaderPlaceholder(columnFieldIndex, ui, true);
            }

            hideColumn(columnFieldIndex, unlockedBrowseBody);
            insertBodyPlaceholder(columnFieldIndex, unlockedBrowseBody, ui, true);
        }

        function changeBodyPlaceholder(_: unknown, ui: JQueryUI.SortableUIParams)
        {
            let sibling = ui.placeholder.prev(`.${classNames.browseHeaderDraggable}`);
            let columnIndexOfSibling: number;
            let insertAfter = false;

            if (sibling.length > 0)
            {
                columnIndexOfSibling = (sibling.data() as SortableColumnData).columnIndex;
                insertAfter = true;
            }
            else
            {
                sibling = ui.placeholder.next(`.${classNames.browseHeaderDraggable}`);
                columnIndexOfSibling = (sibling.data() as SortableColumnData).columnIndex;
            }

            if (locked)
            {
                removeBodyPlaceholder(lockedBrowseBody);
                insertBodyPlaceholder(columnIndexOfSibling, lockedBrowseBody, ui, insertAfter);
                removeUnlockedHeaderPlaceholder();
                insertUnlockedHeaderPlaceholder(columnIndexOfSibling, ui, insertAfter);
            }

            removeBodyPlaceholder(unlockedBrowseBody);
            insertBodyPlaceholder(columnIndexOfSibling, unlockedBrowseBody, ui, insertAfter);
        }

        function stopBodyPlaceholder()
        {
            if (locked)
            {
                removeBodyPlaceholder(lockedBrowseBody);
                lockedBrowseBody.find(`.${classNames.columnDragging}`).removeClass(classNames.columnDragging);
                removeUnlockedHeaderPlaceholder();
                unlockedHeader.find(`.${classNames.columnDragging}`).removeClass(classNames.columnDragging);
            }
            removeBodyPlaceholder(unlockedBrowseBody);
            unlockedBrowseBody.find(`.${classNames.columnDragging}`).removeClass(classNames.columnDragging);
        }
    });
}

function exportBrowse(this: HTMLElement | JQuery)
{
    const clickedElement = $(this);
    const dov = clickedElement.closest(`.${classNames.dataObjectViewer}`);
    let dialog: ModalDialog | undefined;

    if (dov.length > 0 && isDirty(dov))
    {
        const buttons =
        [
            { text: "Export without Saving", icon: ButtonIcon.Check, click: doExport },
            { text: ButtonText.Cancel, icon: ButtonIcon.Cancel }
        ];

        dialog = showCriticalDialog("Warning",
            "<span style=\"font-weight:bold\">Are you sure you want to export without saving?</span>\n" +
            "Any unsaved changes will not be included in the export.",
            buttons, {});
    }
    else
    {
        doExport();
    }

    function doExport()
    {
        dialog?.close();

        const tmpUnloadCheck = skipUnloadCheck;

        setSkipUnloadCheck(true);
        transformBrowse(clickedElement, "GetBrowseExport",
        {
            openNewWindow: false,
            downloadOnMobile: true
        });
        setSkipUnloadCheck(tmpUnloadCheck);
    }
}

function showAuditLegend(this: HTMLElement | JQuery)
{
    const legendButton = $(this);
    showDialog("Legend", buildPopup, [DEFAULT_CLOSE_BUTTON], { anchorTo: legendButton });

    function buildPopup()
    {
        return $.ajax(
        {
            url: `${virtualDir}SkySys/Browse/AuditBrowseLegend/`,
            type: "POST",
            dataType: "viewparthtml",
            activityIndicator: { hideGlass: true }
        });
    }
}

function transformBrowse(button: JQuery, action: string, submitMode: Partial<SubmitFormOptions>)
{
    const browseData = button.data() as TransformBrowseData;
    if ($.isEmptyObject(browseData))
    {
        return;
    }

    const browse = getBrowseById(browseData.browseId);
    if (!browse)
    {
        return;
    }

    const data = $.extend({}, browseData, getRequiredBrowseData(browse, {})) as Dictionary<string, string>;

    if (submitMode.openNewWindow)
    {
        data.selectMode = undefined;
    }

    const cols = browse.columnFieldNames?.length ?? 0;
    const excelMaxRows = 1048576;
    const excelMaxCols = 16384;
    const isExcelType = browseData.exportType === "XLSX";

    if (!isExcelType)
    {
        doExport();
        return;
    }
    if (cols === 0)
    {
        showErrorDialog("Unable to export to XLSX when the list has zero columns.", "Please add columns and try exporting again, or export as a CSV instead.");
    }
    else if (cols > excelMaxCols)
    {
        showErrorDialog(`Unable to export to XLSX when the list has more than ${excelMaxCols.toLocaleString()} columns.`, "Please remove columns and try exporting again, or export as a CSV instead.");
    }
    else
    {
        getBrowseRowCount(browse, data).then(function (rowCount)
        {
            if (rowCount > excelMaxRows)
            {
                showErrorDialog(`Unable to export to XLSX when the list has more than ${excelMaxRows.toLocaleString()} rows.`, "Please filter the list to reduce the number of rows, or export as a CSV instead.");
            }
            else
            {
                doExport();
            }
        });
    }

    function doExport()
    {
        const url = `${virtualDir}${browse!.routeModule}/${browse!.routeObject}/${action}`;
        submitForm(url, data, submitMode);
    }
}

async function getBrowseRowCount(browse: Browse, data: Record<string, unknown>)
{
    if (browse.rowCount !== null && browse.rowCount !== undefined)
    {
        return browse.rowCount;
    }

    const response = await $.ajax(
    {
        url: `${virtualDir}${browse.routeModule}/${browse.routeObject}/GetRecordCount`,
        type: "POST",
        dataType: "JSON",
        data: data,
        activityIndicator: { hideGlass: true },
    }) as { RecordCount: number };

    browse.rowCount = response.RecordCount;
    return browse.rowCount;
}

function wireUpExpandCollapseBrowseButton(browse: JQuery)
{
    const browseId = browse.attr("id");
    browse.find(`.${classNames.expandCollapseBrowsePanel}`).each(function ()
    {
        const collapseButton = $(this);
        const collapsibleContainer = collapseButton.closest(`.${classNames.bottomCollapsibleBrowseContainer}`);
        const primaryBrowseContainer = collapsibleContainer.siblings(`.${classNames.topExpandableBrowseContainer}`);
        const primaryBrowse = primaryBrowseContainer.find(`.${classNames.browse}`);
        const primaryBrowseId = primaryBrowse.attr("id")!;

        collapsibleContainer.off(`BrowseExpandCollapseEvent.${browseId}`)
            .on(`BrowseExpandCollapseEvent.${browseId}`, expandCollapseBrowse);

        collapseButtonOnClick();

        function expandCollapseBrowse(_event: JQuery.TriggeredEvent, browsesAreReturningToNormalHeight: boolean)
        {
            if (collapsibleContainer.length > 0)
            {
                const mainSelectedBrowse = collapsibleContainer.find(`.${classNames.mainSelectedBrowse}`);
                if (mainSelectedBrowse.length > 0)
                {
                    const prevBrowseId = collapsibleContainer.prev().find(`.${classNames.browse}`).first().attr("id")!;
                    const browse = getBrowseById(prevBrowseId);
                    if (browse)
                    {
                        const options =
                        {
                            loadRelatedBrowses: false,
                            updateBrowseSeekInfo: false,
                            setCurrentBrowseName: true
                        };
                        setCurrentRecord(prevBrowseId, browse.currentRow, options);
                    }
                }
                animateBrowseExpandCollapse(browsesAreReturningToNormalHeight);
            }
        }

        function collapseButtonOnClick()
        {
            collapseButton.on("click", function ()
            {
                const browsesAreReturningToNormalHeight = collapsibleContainer.hasClass(classNames.bottomBrowsesCollapsed);
                skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                {
                    if (wasDirty)
                    {
                        setSkipUnloadCheck(true);
                    }
                    updateCollapsibleBrowseState(browsesAreReturningToNormalHeight);
                    collapsibleContainer.trigger("BrowseExpandCollapseEvent", browsesAreReturningToNormalHeight);
                    toggleCollapseButton(collapseButton, browsesAreReturningToNormalHeight);
                });
            });
        }

        function animateBrowseExpandCollapse(returnToNormalHeight: boolean)
        {
            collapseButton.off("click");

            let primaryBrowseAnimation;
            let collapsibleContainerAnimation;
            if (returnToNormalHeight)
            {
                primaryBrowseAnimation = primaryBrowseContainer.switchClass("topBrowseExpanded", "topBrowseNormalHeight", "fast").promise();
                collapsibleContainerAnimation = collapsibleContainer.switchClass("bottomBrowsesCollapsed", "bottomBrowsesNormalHeight", "fast", undefined, function ()
                {
                    $(window).trigger("resize"); //reflow responsive controls
                }).promise();
            }
            else
            {
                primaryBrowseAnimation = primaryBrowseContainer.switchClass("topBrowseNormalHeight", "topBrowseExpanded", "fast").promise();
                collapsibleContainerAnimation = collapsibleContainer.switchClass("bottomBrowsesNormalHeight", "bottomBrowsesCollapsed", "fast", undefined, function ()
                {
                    if (collapsibleContainer.find(`.${classNames.selectedDetailsRow}`).length > 0)
                    {
                        browseDetailsPanel.refreshDetailsPanel(primaryBrowseId);
                    }
                }).promise();
            }

            $.when(primaryBrowseAnimation, collapsibleContainerAnimation).done(function () { onAnimationDone(collapsibleContainer); });
        }

        function scrollTopBrowseRowIntoView()
        {
            const topBrowseHasCurrentSelectedRow = primaryBrowse.find(`.${classNames.lockedBrowseBody} .${classNames.current}, .${classNames.unlockedBrowseBody} .${classNames.current}`);
            if (topBrowseHasCurrentSelectedRow.length !== 0)
            {
                topBrowseHasCurrentSelectedRow.each(function () { this.scrollIntoView(); });
            }
        }

        function updateCollapsibleBrowseState(isNormalHeight: boolean)
        {
            $.ajax(
            {
                url: `${virtualDir}SkySys/Browse/UpdateCollapsibleBrowseState`,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { hideGlass: true },
                data:
                {
                    IsNormalHeight: isNormalHeight
                }
            });
        }

        function onAnimationDone(collapsibleContainer: JQuery)
        {
            const browse = getBrowseById(primaryBrowseId)!;
            collapsibleContainer.css("overflow", "");
            collapseButtonOnClick();
            resizeLockedBrowseBodyForHorizontalScrollBar(browse);
            scrollTopBrowseRowIntoView();
        }
    });

    function toggleCollapseButton(button: JQuery, expand: boolean)
    {
        button.find("svg").replaceWith(getSvg(expand ? "ChevronDown" : "ChevronUp", "BrowseExpandCollapse"));
    }
}

function initMobileBrowse(containerDiv: JQuery, dataHtml: string, browse: Browse)
{
    /* don't process the mobile browse data if there is no data, the data is an input, or if we have already processed the data */
    if (!dataHtml || dataHtml.startsWith("<input") || containerDiv.find(`.${mobileBrowseClasses.mobileBrowseBody}`).length)
    {
        return Promise.resolve();
    }

    resetContainer();

    let placeholder;

    if (!containerDiv.is(":visible"))
    {
        placeholder = $("<div>", { css: { display: "none" } });
        placeholder.insertBefore(containerDiv);
        containerDiv.appendTo(document.body);
    }

    const scriptsAndPartialsLoadedPromise = initializeMobileBrowseData();

    // Apply carried-over totals before calling applyMobileLockedColumn.
    // Without this we would have to call it again in finishRegistration.
    if (browse.totals?.data !== undefined)
    {
        displayBrowseTotals(browse, containerDiv.find(`.${classNames.browseBodyTotalsSection}`));
    }

    const browseBody = containerDiv.find(`.${classNames.browseBody}`);
    const unlockedBrowseBody = containerDiv.find(`.${classNames.unlockedBrowseBody}`);

    browseBody.addClass(mobileBrowseClasses.mobileBrowseBody);

    removeFirstColumnIfEmpty();

    combineRowIcons();

    applyMobileLockedColumn(containerDiv, browseBody, unlockedBrowseBody);

    setEvents();

    if (placeholder)
    {
        containerDiv.insertAfter(placeholder);
        placeholder.remove();
    }

    const browseHeaderScrollData =
    {
        origScroll: undefined as number | undefined,
        isScrollable: undefined as boolean | undefined,
        distances: [] as number[],
        times: [] as number[]
    };

    return scriptsAndPartialsLoadedPromise;

    function initializeMobileBrowseData()
    {
        //remove widths from browse data
        const { html: processedHtml, loaded: loadedPromise } = processViewPartHtmlSeparately(prepMobileBrowseData(dataHtml));
        const dataFragment = $("<div>").append(processedHtml);

        //remove unwanted browse elements
        dataFragment.find(`#browse_lockedHeader, .${classNames.lockedBrowseBodyScrollWrapper}, .${classNames.browseHeaderSpacer}`).remove();

        //remove header if there is only one browse or is explicitly hidden in mobile
        const activeBrowses = getClosestContentPanel(containerDiv).find(`.${classNames.browse}`);
        if (activeBrowses.length <= 1 || containerDiv.hasClass(classNames.hideHeaderMobile))
        {
            dataFragment.find(`.${classNames.browseSectionHeader}`).closest(`.${classNames.containerToolbar}`).remove();
        }

        //add the header row to the browse body within a thead
        $(`<thead>${dataFragment.find(`.${classNames.unlockedHeader} tbody`).html()}</thead>`).insertBefore(dataFragment.find(`.${classNames.appendMobileBrowseHeader}`));
        const totalsSection = dataFragment.find(`.${classNames.browseBodyTotalsSection}`);
        if (totalsSection.length)
        {
            const footer = $("<tfoot>", { class: totalsSection.attr("class") });
            footer.append(totalsSection.find("tr").clone()).insertAfter(dataFragment.find(`.${classNames.appendMobileBrowseFooter}`));
        }

        containerDiv.addClass(mobileBrowseClasses.mobileBrowseContainer);
        containerDiv.append(dataFragment.children());
        return loadedPromise;
    }

    function resetContainer()
    {
        containerDiv.html("");
        containerDiv.removeClass([mobileBrowseClasses.mobileBrowseContainer, mobileBrowseClasses.hasHeaderShadow, mobileBrowseClasses.hasColumnShadow].join(" "));
    }

    function removeFirstColumnIfEmpty()
    {
        const table = unlockedBrowseBody.find(`.${classNames.unlockedBrowseTable}`)[0] as HTMLTableElement | undefined;
        if (!table)
        {
            return;
        }

        const firstColumnCells: JQuery[] = [];
        let anyCellHasContent = false;
        for (const row of table.rows)
        {
            const cell = $(row.cells[0]);

            if (checkIfCellHasContent(cell))
            {
                anyCellHasContent = true;
                break;
            }
            else
            {
                firstColumnCells.push(cell);
            }
        }

        if (!anyCellHasContent)
        {
            // if the first column of the unlocked table is removed, also remove the first column from the locked table
            const headerTable = containerDiv.find(`.${classNames.browseHeader} > .${classNames.unlockedHeader} > table`)[0] as HTMLTableElement | undefined;
            if (headerTable !== undefined && headerTable.rows.length > 0 && headerTable.rows[0].cells.length > 0)
            {
                firstColumnCells.push($(headerTable.rows[0].cells[0]));
            }

            firstColumnCells.map(function (cell)
            {
                cell.remove();
            });
        }

        function checkIfCellHasContent(cell: JQuery)
        {
            const contentTags = "svg,img,:input:not([type=hidden])";
            return cell.length && (cell.text().trim().length || cell.find(contentTags).length);
        }
    }

    function combineRowIcons()
    {
        /* remove new window links in mobile */
        unlockedBrowseBody.find(`.${classNames.svg}.${classNames.newWindow}`).each(function ()
        {
            $(this).closest(`.${classNames.svgAnchor}`).remove();
        });

        /* combine row icons into the more icon */
        unlockedBrowseBody.find(`svg.${classNames.rowAction}`).each(function ()
        {
            const rowActionLink = $(this).parent(`.${classNames.svgAnchor}`);
            if (!rowActionLink.length)
            {
                return;
            }
            let onClickStr = rowActionLink.attr("onclick")!;
            rowActionLink.closest("td").find(`.${classNames.svgAnchor}`).not(rowActionLink).each(function ()
            {
                const button = $(this);
                const buttonId = this.id;
                const iconHref = button.find("use").attr("href")!;
                const icon = /#svg-(\w+)/.exec(iconHref)?.[1] as SvgKey;

                let text = button.find(`.${classNames.anchorText}`).text();
                if (text === "")
                {
                    switch (icon)
                    {
                        case "RowOpen":
                            text = "Details";
                            break;
                        case "RunReport":
                            text = "Run Report";
                            break;
                        case "Info":
                            text = "Info";
                            break;
                        default:
                            text = icon;
                            break;
                    }
                }

                const menuOption: MenuItemDefinition =
                {
                    text: text,
                    icon: icon,
                    data: { "click-target-id": buttonId }
                };

                onClickStr = onClickStr.replace("skyward.browse.rowPopupMenu([", `skyward.browse.rowPopupMenu([${JSON.stringify(menuOption)},`);
                button.hide();
            });
            rowActionLink.attr("onclick", onClickStr);
        });
    }

    function applyBoxShadowCss(hasShadowClass: string, scrollValue: number, containerDiv: JQuery)
    {
        if (scrollValue > 0)
        {
            if (!containerDiv.hasClass(hasShadowClass))
            {
                containerDiv.css("willChange", "box-shadow");
                containerDiv.addClass(hasShadowClass);
                containerDiv.css("willChange", "");
            }
        }
        else if (containerDiv.hasClass(hasShadowClass))
        {
            containerDiv.css("willChange", "box-shadow");
            containerDiv.removeClass(hasShadowClass);
            containerDiv.css("willChange", "");
        }
    }

    function setEvents()
    {
        /* scroll in the X direction */
        unlockedBrowseBody.on("scroll", function ()
        {
            applyBoxShadowCss(mobileBrowseClasses.hasColumnShadow, this.scrollLeft, containerDiv);
        });

        /* scroll in the Y direction */
        browseBody.on("scroll", function ()
        {
            applyBoxShadowCss(mobileBrowseClasses.hasHeaderShadow, this.scrollTop, containerDiv);
        });

        /* this fixes an issue in iOS where scrolling breaks after an orientation change */
        $(window).on("orientationchange", function ()
        {
            $(document.body).addClass(classNames.translateZ);
            window.setTimeout(function ()
            {
                $(document.body).removeClass(classNames.translateZ);
            }, 10);
        });

        /* add click events to the header elements (one in the browseBody, the other in the fixed browseHeader). */
        /* Don't bind events to just the containerDiv, it is reused if the browse is reloaded. */
        /* Using delegated click events here allows us to bind a total of 2 listeners.  If we bound to the browseHeaderColumn elements we would have 2X more listeners than browse columns. */
        $().add(browseBody.find(`.${classNames.unlockedHeaderTableRow}`)).add(containerDiv.find(`.${classNames.browseHeader}`)).on("click", `.${classNames.browseHeaderColumn}`, function ()
        {
            const td = $(this);
            const cog = td.find(`.${classNames.browseColumnFilterMenuLaunch}`);
            if (cog.length)
            {
                browseHeaderColumnClick.apply(cog);
                return;
            }
            const sort = td.find(`.${classNames.browseColumnHeaderSort}`);
            if (sort.length)
            {
                changeSort.apply(sort);
                return;
            }
        });

        /* simulate momentum scrolling on the fixed browse header */
        containerDiv.find(`.${classNames.unlockedHeader}`).trigger("swipe", function (_event: JQuery.TriggeredEvent, phase: string, direction: JQueryTouchSwipe.Direction | null, distance: number)
        {
            let localDistance = distance;
            if (direction === "right")
            {
                localDistance *= -1;
            }

            switch (phase)
            {
                case "start":
                    browseHeaderScrollData.origScroll = unlockedBrowseBody.stop().scrollLeft()!;
                    browseHeaderScrollData.isScrollable = unlockedBrowseBody.is(":scrollable");
                    browseHeaderScrollData.distances = [];
                    browseHeaderScrollData.times = [];
                    break;
                case "move":
                {
                    if (direction !== "right" && direction !== "left")
                    {
                        return;
                    }
                    if (!browseHeaderScrollData.isScrollable)
                    {
                        return;
                    }
                    unlockedBrowseBody.scrollLeft(browseHeaderScrollData.origScroll! + localDistance);
                    window.cancelTouchSwipe = true; //prevent menu from opening;
                    addShiftValue(browseHeaderScrollData.distances, localDistance);
                    addShiftValue(browseHeaderScrollData.times, new Date().getTime());
                    break;
                }
                case "end":
                case "cancel":
                {
                    unlockedBrowseBody.on("touchstart", interruptFinishScroll);

                    const momentumScrollDistance = getMomentumScrollDistance(browseHeaderScrollData.distances, browseHeaderScrollData.times);

                    if (momentumScrollDistance !== 0)
                    {
                        unlockedBrowseBody.stop().animate({ scrollLeft: (unlockedBrowseBody.scrollLeft()! + momentumScrollDistance) }, 800, "easeOutExpo", function ()
                        {
                            unlockedBrowseBody.off("touchstart", interruptFinishScroll);
                        });
                    }
                    break;
                }
            }

            function interruptFinishScroll()
            {
                unlockedBrowseBody.stop();
            }

            function addShiftValue(array: number[], val: number)
            {
                if (array.length > 1)
                {
                    array.shift();
                }
                array.push(val);
            }

            function getMomentumScrollDistance(distances: number[], times: number[])
            {
                let scrollDistance = 0;
                if (distances.length === 2 && times.length === 2)
                {
                    const deltaDistance = distances[1] - distances[0];
                    const deltaTime = times[1] - times[0];
                    const deltaDistOverTime = deltaDistance / deltaTime;
                    const scrollFactor = 150;

                    scrollDistance = Math.min(scrollFactor * 4, deltaDistOverTime * scrollFactor) || 0;
                }

                return scrollDistance;
            }
        });
    }
}

function getBrowseTypeSpecificData(browse: Browse)
{
    const browseType = browse.browseType;

    const browseTypeData =
    {
        browseType: browseType
    };

    if (browseType === "Editable")
    {
        $.extend(browseTypeData, getEditableBrowseData(browse as unknown as EditableBrowse));
    }
    else if (browseType === "DistinctMultiSelect")
    {
        $.extend(browseTypeData, getDistinctMultiSelectEELData(browse));
    }
    else if (browseType === "Checkbox")
    {
        $.extend(browseTypeData, getCheckboxBrowseData(browse as unknown as CheckboxBrowse));
    }

    return browseTypeData;
}

function getRelatedBrowse(browseName: string)
{
    const browse = getBrowseById(browseName);
    if (!browse)
    {
        return $.Deferred().reject().promise();
    }

    const browseExistsOnPage = browse.browse && browse.browse.length > 0 && $.contains(document.body, browse.browse[0]);

    if (!browseExistsOnPage)
    {
        return $.Deferred().reject().promise();
    }

    const parentBrowse = getParentBrowse(browse)!;
    const isParentEmpty = parentBrowse.primaryKeys!.length === 0;
    const parentKey = getCurrentRecordTargetId(parentBrowse.browseName);

    if (browse.totals?.container.length)
    {
        browse.totals.data = undefined;
        if (browse.totals.ajaxRequest !== undefined)
        {
            browse.totals.ajaxRequest.abort();
            browse.totals.ajaxRequest = undefined;
        }
    }

    const data: BrowseData =
    {
        seekId: -1,
        pagingType: "FirstPage",
        isRelatedBrowse: "true",
        hidePrimaryBrowseButton: isParentEmpty,
        parentPrimaryKeyID: parentKey,
        parentBrowseRequestDataHash: parentBrowse.requestDataHash,
    };

    return get(browseName, data);
}

function shouldProcessMobileBrowse(browse: Browse | null)
{
    let shouldProcess = mobileAccess;
    if (browse)
    {
        const browseDiv = browse.browse ?? $(`#${browse.id}`);
        if (browse.browseType === "Tile" || (browseDiv.length && browseDiv.is("[data-skip-mobile-processing]")))
        {
            shouldProcess = false;
        }
    }
    return shouldProcess;
}

function requestBrowse(browseId: string, browse: Browse, browseData: BrowseData, action: string, signal?: AbortSignal)
{
    const browseLoaded = $.Deferred();
    if (isInWorkflow(browse))
    {
        addDisableNavigationPromise(browseLoaded, false);
    }

    const browseIsCodeEEL = browseData.codeEelName != null;
    const currentBrowse = getCurrentBrowse();
    const loadingNewDetailsPanel = (!browseIsCodeEEL && browseDetailsPanel.currentDetailsBrowse === browseData.browseName)
            || (browse.relatedBrowses && currentBrowse && browse.relatedBrowses.some((relatedBrowse) => relatedBrowse.BrowseID === currentBrowse.browseId));

    if (loadingNewDetailsPanel)
    {
        return skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
        {
            if (wasDirty)
            {
                setSkipUnloadCheck(true);
            }
            return doRequest();
        });
    }

    return doRequest();

    function doRequest()
    {
        //if the browse has been rendered before, its primary button will know what control it should modify, pass that info along to persist it
        if (browse.currentRow !== null)
        {
            //Make sure that the button exists & has data before attempting to use the value.
            const newButton = $(`#${browseId}_newButton`);
            if (newButton.length > 0)
            {
                const buttonData = newButton.data();
                if (!$.isEmptyObject(buttonData))
                {
                    browseData.pageStateControlValues = JSON.stringify(buttonData);
                }
            }
        }

        const localStopwatch = stopwatch();
        const totalStopwatch = stopwatch();

        browse.timestamp ??= 0;
        const repeater = browse.browse ? browse.browse.closest(`.${classNames.repeater}`) : $();

        if (repeater.length)
        {
            const renderedBrowses = (repeater.data("renderedBrowses") as Record<string, boolean> | undefined) ?? {};
            if (!renderedBrowses[browse.routeHash])
            {
                renderedBrowses[browse.routeHash] = true;
                repeater.data("renderedBrowses", renderedBrowses);
            }
            else
            {
                browseData.isRepeatedBrowse = true;
            }
        }

        const url = `${virtualDir}${browse.routeModule}/${browse.routeObject}/${action}`;

        // if we can find the browse in the detailsPreview container then we want to hide the button in the details we are opening
        browseData.hidePreviewDetailsButton = !!browse.hidePreviewDetailsButton || skyward.detailsPanel.containsElement(browse.browse!);
        browseData.detailsPanelType = browse.detailsPanelType;

        const requestStopwatch = stopwatch();

        const browseRequest = $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "JSON",
                data: browseData,
                activityIndicator: { hideGlass: true },
                signal: signal,
                error: function (xhr, status, error)
                {
                    console.error("AJAX error:", status, error, xhr.responseText);

                    if (browseData.returnSearchCondition)
                    {
                        window.parent?.postMessage(
                        {
                            type: "forbidden",
                            data:
                            {
                                error: "Unable to retrieve browse."
                            }
                        }, "*");
                    }
                },
                success: function (data: BrowseRequestData | undefined)
                {
                    if (browseData.returnSearchCondition)
                    {
                        if (!data?.success)
                        {
                            window.parent?.postMessage({
                                type: "cannotRecover"
                            }, "*");
                            return;
                        }

                        window.parent?.postMessage({
                            type: "gatherSearchCondition",
                            data:
                            {
                                condition: data?.condition,
                                conditionHash: data?.conditionHash,
                                browseFilterID: browseData.browseFilterId,
                                pageModule: browseData.pageModule,
                                pageObject: browseData.pageObject,
                                dataModule: browseData.dataModule,
                                dataObject: browseData.dataObject,
                                routeModule: browseData.routeModule,
                                routeObject: browseData.routeObject,
                                browseName: browseData.browseName
                            } as GatherSearchConditionMessageData
                        }, "*");
                        return;
                    }

                    const totalActionTime = requestStopwatch.duration();
                    if (!data)
                    {
                        reportException(new SkywardException("Browse response data was undefined"));
                        return;
                    }

                    if (data.usageHistoryID)
                    {
                        completePerformanceMonitoring(data.usageHistoryID, totalActionTime);
                    }
                    const downloadTime = localStopwatch.duration();

                    const div = $(`#${browse.id}`);

                    // Remove any skyVue instances that are in the div to trigger Vue deregistration
                    div.find(`.${classNames.skyVue}`).remove();

                    // Don't add the browse to the DOM until the document is ready, so our skyward.window.notifyDOMLoad()
                    // won't interfere with the one fired when the document loads
                    $(function ()
                    {
                        //since requests are async, make sure to always display the most recently requested browse
                        if (data.timestamp > browse.timestamp!)
                        {
                            browse.timestamp = data.timestamp;

                            localStopwatch.restart();


                            if (div.length < 1)
                            {
                                return;
                            }

                            if (shouldProcessMobileBrowse(browse))
                            {
                                div.empty();
                                initMobileBrowse(div, data.html, browse).then(() =>
                                {
                                    div.attr("aria-label", browse.displayName!);
                                    browseLoaded.resolve();
                                });
                            }
                            else
                            {
                                processViewPartHtml(data.html).then(function (html)
                                {
                                    const sectionHeaderTag = $(html).find(`.${classNames.sectionHeaderText}`);
                                    if (sectionHeaderTag.length > 0)
                                    {
                                        browse.displayName = sectionHeaderTag[0].textContent;
                                        const existingAriaLabeledBy = div.attr("aria-labelledby"); // Browses that are within a template within a repeater might add its own label

                                        const divAriaLabeledBy = existingAriaLabeledBy !== undefined
                                            ? `${existingAriaLabeledBy} ${sectionHeaderTag.attr("id")}`
                                            : sectionHeaderTag.attr("id")!;
                                        div.attr("aria-labelledby", divAriaLabeledBy);
                                    }
                                    else
                                    {
                                        // Browse is not a major region with its own title
                                        div.removeAttr("role");
                                    }

                                    div.html(html as string);
                                    browseLoaded.resolve();
                                });
                            }
                            browseLoaded.done(function ()
                            {
                                browseLoadedSuccess(browse, data, localStopwatch, totalStopwatch, downloadTime, doRequest);
                            });
                        }
                        else
                        {
                            browseLoaded.resolve();
                        }

                        if (typeof browse.successCallback === "function")
                        {
                            browseLoaded.done(function ()
                            {
                                browse.successCallback?.();
                            });
                        }

                        // If this is a GetBrowse request, and the getBrowseSearchMode flag is AfterRequest, then perform the search after the GetBrowse request is complete
                        if (browseData.getBrowseSearchMode === "AfterRequest" && action === "GetBrowse")
                        {
                            browseLoaded.done(function ()
                            {
                                performSearch(browseId, browseData);
                            });
                        }

                        browseLoaded.done(() =>
                        {
                            $(window).trigger("resize"); // reflow responsive controls
                        });
                    });
                }
            }
        );

        monitorRequest(browseRequest, browse, browseData, browse.routeModule, browse.routeObject, action);

        // Disposing of the old browse html can be expensive, so do it now, while the ajax request is in flight
        if (browse.body)
        {
            browse.body.html(`<div class="${classNames.browseBodyLoading}">${getImageHtml("getRecordCountPageLoadingGif")} Loading...</div>`);
            browse.totals?.container.addClass(classNames.browseBodyTotalsSectionNotReady);
            // Clean up header widgets now, otherwise they will need to be cleaned by the call to .html() in the success callback
            // Based on https://github.com/jquery/jquery/blob/0ec25a/src/manipulation.js#L423
            $.cleanData(browse.browse![0].getElementsByTagName("*"));
            browse.contentMessageArea = undefined;
        }

        if (loadingNewDetailsPanel)
        {
            skyward.detailsPanel.emptyDetailsPanel();
        }

        // we need to return the whole ajax request here, not just the promise, since some callers may want to abort the request.
        return browseRequest;
    }
}

function setupBrowseDependency(browse: Browse)
{
    const dynamicFilterData = browse.dynamicFilterData as TextBoxData | undefined;
    const container = getScopeContainer(browse.browse as JQueryInput);
    const dependentData: DependentRule = { Id: browse.browseName, Refresh: "true" };
    setupDependency(dynamicFilterData, dependentData, container);
    browse.browse?.off("refresh").on("refresh", () =>
    {
        updateDependency(browse.browseName);
        return false;
    });
}

function updateBrowseTotalsRequest(browse: Browse)
{
    if (browse.totals)
    {
        if (browse.totals.container.length)
        {
            requestBrowseTotals(browse);
        }
        else
        {
            if (browse.totals.ajaxRequest !== undefined)
            {
                browse.totals.ajaxRequest.abort();
                browse.totals.ajaxRequest = undefined;
            }
            if (browse.totals.nextTimeoutId !== undefined)
            {
                clearTimeout(browse.totals.nextTimeoutId);
                browse.totals.nextTimeoutId = undefined;
            }
        }
    }
}

function getBrowseTotals(browse: Browse)
{
    return $.ajax(
    {
        url: `${virtualDir}${browse.routeModule}/${browse.routeObject}/GetBrowseTotals`,
        type: "POST",
        dataType: "JSON",
        activityIndicator: { hideGlass: true },
        data: getRequiredBrowseData(browse)
    });
}

function requestBrowseTotals(browse: Browse)
{
    const debounceSeconds = 3;
    const totals = browse.totals;
    // we want to send the first request asap
    // subsequent changes are deferred for debounceSeconds
    if (!totals || totals.nextTimeoutId !== undefined || totals.ajaxRequest !== undefined)
    {
        return;
    }

    const timeout = totals.nextRequestTime !== undefined
        ? (totals.nextRequestTime.getTime() - new Date().getTime())
        : 0;

    totals.nextTimeoutId = window.setTimeout(function ()
    {
        totals.nextTimeoutId = undefined;
        totals.ajaxRequest = getBrowseTotals(browse);
        totals.ajaxRequest.then(function (data: BrowseTotalsData)
        {
            // finish debouncing - don't include request time
            totals.ajaxRequest = undefined;
            const nextTotalRequestTime = new Date();
            nextTotalRequestTime.setSeconds(nextTotalRequestTime.getSeconds() + debounceSeconds);
            totals.nextRequestTime = nextTotalRequestTime;

            if (data.success === false)
            {
                totals.data = undefined;
                displayBrowseTotalsError(browse, data);
                return;
            }

            const oldData = totals.data;
            totals.data = data;

            displayBrowseTotals(browse);
            updateMobileTotalColumnWidths(browse, oldData, data);
        });
    }, timeout);
}

function displayBrowseTotalsError(browse: Browse, totalsData?: BrowseTotalsData)
{
    const container = getTotalsContainer(browse);
    if (container === undefined)
    {
        return;
    }

    const columns = getTotalColumns(container);
    for (let i = 0; i < columns.length; i++)
    {
        const column = columns.eq(i);
        const svg = getSvg("RowError", "Error");
        svg.addClass("browseBody__totalColumnError");
        svg.attr("role", "button");
        svg.attr("aria-haspopup", "dialog");
        svg.attr("aria-label", "List Totals Error Information");
        svg.attr("tabindex", "0");
        column.text("");
        column.append(svg);
        svg.on("click", errorSvgClickHandler);
    }

    finishTotalsDisplay(browse, container);

    function errorSvgClickHandler()
    {
        const buttons: ButtonDefinitions = [];

        if (browse.renderViewButton === true)
        {
            buttons.push(
            {
                text: "Select List Totals",
                icon: "Selection",
                click: async () => checkLoadContent("popup", "Workflow", "WorkflowInstance", "Create/SkySys/BrowseView/SelectListTotals", null, totalsData?.totalsPostData, null, undefined, null, false, null, null, null)
            });
        }

        buttons.push(DEFAULT_CLOSE_BUTTON);

        const message = "There was a problem during the request. This could be caused by List Totals attempting to pull too much data. Review the recommendations below to avoid further disruptions.";
        const recommendations = ["Adjust your List Totals to pull less data."];

        if (totalsData?.hasReportingAccess === true)
        {
            recommendations.push("Consider creating a report to summarize large amounts of data.");
        }

        const content = buildRecommendationModalContent(message, recommendations, false, true);

        const dialog = showDialog("More Information", content, buttons);
        dialog.container.css({ maxWidth: "min(600px,90%)" });
    }
}

function displayBrowseTotals(browse: Browse, newBrowseContainer?: JQuery)
{
    const container = getTotalsContainer(browse, newBrowseContainer);
    if (container === undefined)
    {
        return;
    }

    const data = browse.totals?.data;
    if (data !== undefined)
    {
        const columns = getTotalColumns(container);
        for (let i = 0; i < columns.length; i++)
        {
            const column = columns.eq(i);
            const displayColumnIndex = parseInt(column.attr("data-display-column")!);
            column.text(data[browse.columnFieldNames![displayColumnIndex]] as string);
        }
    }

    finishTotalsDisplay(browse, container);
}

function getTotalsContainer(browse: Browse, newBrowseContainer?: JQuery)
{
    const container = newBrowseContainer ?? browse.totals?.container;
    return container !== undefined && container.length > 0 ? container : undefined;
}

function getTotalColumns(container: JQuery)
{
    return container.find(`.${classNames.browseBodyTotalColumn}.${classNames.browseBodyTotalColumnHasData}`);
}

function finishTotalsDisplay(browse: Browse, container: JQuery)
{
    if (browse.totals?.nextTimeoutId === undefined)
    {
        container.removeClass(classNames.browseBodyTotalsSectionNotReady);
    }
}

function updateMobileTotalColumnWidths(browse: Browse, oldData?: BrowseData, newData?: BrowseData)
{
    if (!shouldProcessMobileBrowse(browse))
    {
        return;
    }
    if (oldData && newData && oldData.length === newData.length &&
        Object.keys(newData).every(function (key) { return oldData[key] === newData[key]; }))
    {
        return;
    }
    applyMobileLockedColumn(browse.browse!);
}

export function getParentBrowse(browse: Browse)
{
    for (const browseObject of getAllBrowses())
    {
        if (browseObject?.relatedBrowses && !$.isEmptyObject(browseObject.relatedBrowses) && browseObject.relatedBrowses.find(relatedBrowse => relatedBrowse.BrowseID === browse.id))
        {
            return browseObject;
        }
    }
    return undefined;
}

function getHeaderNumber(browse: Browse)
{
    // If the override is set, honor it.
    if (browse.headerNumber)
    {
        return browse.headerNumber;
    }

    const defaultHeaderNumber = 2;

    if (!browse.browse)
    {
        return defaultHeaderNumber;
    }

    let headerNumber;

    const parentBrowse = getParentBrowse(browse);

    if (parentBrowse)
    {
        headerNumber = (getRequiredBrowseData(parentBrowse).headerNumber as number) + 1;
    }
    else
    {
        headerNumber = defaultHeaderNumber;
        if (browse.browse.closest(`.${classNames.contentArea}`).find(`.${classNames.hasInitialHeader}`).length)
        {
            headerNumber++;
        }
    }
    return headerNumber;
}

function updateTotalColumnOffsets(elements: JQuery, left: number)
{
    let totalLeft = left;
    const accumulator = [left];
    let element: JQuery;

    for (const el of elements)
    {
        element = $(el);
        if (element.hasClass(classNames.browseBodyLockedTotalColumn))
        {
            totalLeft += parseFloat(element.css("width"));
            accumulator.push(totalLeft);
        }
        else
        {
            break;
        }
    }

    for (let i = 0; i < accumulator.length - 1; i++)
    {
        element = $(elements[i]);
        element.css("left", `${accumulator[i]}px`);
    }

    $(elements[accumulator.length - 1]).css("marginLeft", `${accumulator[accumulator.length - 1]}px`);
}

function getMainSelectedBrowse()
{
    const browseElement = $(`.${classNames.modalLayerContainer}`).last().find(`.${classNames.mainSelectedBrowse}`).add(`#master .${classNames.mainSelectedBrowse}`).first();
    return getContainingBrowse(browseElement);
}

function gatherDataForError()
{
    const browses: Record<string, { title: string, attached: boolean}> = {};

    for (const browseId of getAllBrowseIds())
    {
        const browse = getBrowseById(browseId)!;
        browses[browseId] =
        {
            title: getDebugName(browse),
            attached: !!document.getElementById(browseId)
        };
    }

    return {
        browses: browses,
        detailsPanelOpen: !!browseDetailsPanel.currentDetailsBrowse,
        mainSelectedBrowseId: getMainSelectedBrowse()?.id
    };
}

function rowClick(browseName: string, browseCell: JQuery)
{
    const browse = getBrowseById(browseName);
    if (!browse)
    {
        return;
    }

    const row = browseCell.closest(`.${classNames.browseRow}`);
    const alreadyMainSelectedRow = row.hasClass(classNames.current) && browse.browse?.hasClass(classNames.mainSelectedBrowse);

    if (alreadyMainSelectedRow)
    {
        return;
    }

    const data = browseCell.data();

    rowChange(browseName, data.row, browse.currentRow !== data.row);
}

function changeSort(this: HTMLElement | JQuery)
{
    const clickedElement = $(this);
    const browseData = clickedElement.data() as ChangePageData;

    const browse = getContainingBrowse(this);
    if (!browse)
    {
        return;
    }

    const data = getRequiredBrowseData(browse, browseData);
    data.sortField = browseData.sortField;
    data.sortAction = skyward.keys.globalShiftPressed ? "add" : "set";
    data.seekId = -1;
    data.browseViewSortChange = true;
    data.descending = (browseData.sortDescending != null) ? !browseData.sortDescending : false;

    requestBrowse(browse.id, browse, data, "ChangeBrowseSort");
}

function addBrowseControlsClickEvents(browse: Browse)
{
    browse.controls?.on("click", `.${classNames.addDashboardTile}`, function ()
    {
        addTileListener(browse);
    });
}

function addTileListener(browse: Browse)
{
    const tileAddedEvent = "WorkflowCompleted.SkySys.DashboardItem.DashboardItemConfigurationWorkflow";
    const body = $(document.body);
    body.one(tileAddedEvent, function ()
    {
        if (browse.contentMessageArea)
        {
            browse.contentMessageArea.setConfirmationMessage("Your tile has been successfully added to your dashboard!");
            browse.contentMessageArea.showConfirmation();
        }
    });
}

function addBrowseBodyClickEvents(browseData: Browse)
{
    const unlockedBody = browseData.unlockedBody;
    if (unlockedBody && $(unlockedBody[0]).find(`.${classNames.noRecordsInBrowse}.${classNames.browseRow}`).length > 0)
    {
        $(browseData.unlockedHeader![0]).find("caption").remove();
        return;
    }

    browseData.body?.on("click", `.${classNames.viewAndFilter}.${classNames.reset}`, function ()
    {
        const data = $(this).data();
        resetViewAndFilter(data.browseViewId, data.browseFilterId, data.browseName);
    });

    if (browseData.selectMode)
    {
        browseData.body?.on("click", `.${classNames.selectRecord}`, function ()
        {
            const selectId = $(this).data("select-id") as string;
            selectRecord(browseData.id, selectId);
        });
    }  
}

// Quick selection filtering: while CTRL is held, clicking cells builds up a pending selection
// filter (filterJson). Releasing CTRL applies the accumulated filter to the browse.
function addQuickSelectionFilter(browseData: Browse)
{
    if (!browseData.renderFilterButton || !browseData.body?.length)
    {
        return;
    }

    // "quickFilterEnabled" marks the browse as supporting quick filtering at all.
    // "quickFilterActive" drives the hover affordances and is dropped while the user has text
    // selected, so the filter icon and highlight get out of the way of a copy. (PR 6717946)
    browseData.browse?.addClass("quickFilterEnabled").addClass(classNames.quickFilterActive);

    const selectionChangeEvent = `selectionchange.quickSelectionFilter${browseData.id}`;

    // Selecting text is the only signal that separates a copy from a filter click -- both
    // gestures are CTRL plus the mouse.
    $(document).off(selectionChangeEvent, updateQuickFilterCancelled).on(selectionChangeEvent, updateQuickFilterCancelled);
    skyward.window.registerDOMUnloadCallback(browseData.body)
        ?.then(cleanupSelectionChangeHandler)
        .catch(() => { });

    // Pending filter being built while CTRL is held; keyed by field name.
    let filterJson = {} as Record<string, any>;
    const trueOnly = "TrueOnly";
    const dmsJson = "DmsJson";

    // Prevent the page from zooming when using the scroll wheel over a browse column when CTRL is
    // pressed, so the wheel scrolls the browse instead. A browse with too few records to scroll has
    // nothing to take the wheel for, so leave the event alone and let the browser zoom.
    browseData.body?.find(".unlockedBrowseBody").add(browseData?.lockedBody ?? $()).on("wheel", function (jQueryEvent)
    {
        const event = jQueryEvent.originalEvent as WheelEvent;
        if (!event.ctrlKey || !canScrollVertically(this) || !isOverBrowseCell(event.target))
        {
            return;
        }

        event.preventDefault();
        if (event.target !== browseData.lockedBody?.get(0))
        {
            this.scrollTop += event.deltaY;
        }
    });

    // Seed the pending filter with any selection filters already applied to the browse,
    // so adding/removing values during this session starts from the current server state.
    browseData.header?.find(".browseHeaderColumn[data-selected-values]").each(function ()
    {
        const headerColumn = $(this);
        const fieldName = headerColumn.data("field-name") as string | undefined;
        if (!fieldName)
        {
            return;
        }
        const selectedValues = headerColumn.data("selected-values") as Record<string, string>;
        const isBoolean = headerColumn.data("is-boolean") === true;
        for (const [rawValue, displayValue] of Object.entries(selectedValues))
        {
            addFilterValue(fieldName, rawValue, displayValue, isBoolean);
        }
    });

    // Snapshot of the filter taken when CTRL is pressed, used to detect whether anything changed.
    let cachedFilterState: string;

    // Cells highlighted at CTRL down, so an abort can restore exactly the server's state.
    let cachedHighlights: JQuery | undefined;

    // Latched once text is selected: quick filter stays aborted for the rest of this CTRL hold.
    // Re-arming it whenever the selection collapsed made the affordances flicker in and out
    // while the user was still selecting, which read as broken. (PR 6717946)
    let quickFilterCancelled = false;

    // On CTRL up, if the selection changed while CTRL was held, request the browse with the new filter.
    $(document.body).on("keyStateChanged", function (_event, eventData: any)
    {
        if (eventData.eventType === "keyDown" && eventData.ctrlKey)
        {
            beginQuickFilterSession();
            return;
        }
        else if (eventData.eventType !== "keyUp" || !eventData.ctrlKey || cachedFilterState === undefined || cachedFilterState === JSON.stringify(filterJson))
        {
            return;
        }

        const browse = getBrowseById(browseData.id);

        if (!browse)
        {
            filterJson = {};
            return;
        }

        const data = getRequiredBrowseData(browse);
        data.seekId = -1;
        data.filter = JSON.stringify(filterJson);

        requestBrowse(browseData.id, browse, data, "UpdateFilterAndView").then(() =>
        {
            filterJson = {};
        });
    });

    // CTRL + click on a cell toggles that cell's value in the pending filter and highlights
    // every matching cell in the same column.
    browseData.body?.on("click", `.${classNames.browseDataCell} div:first-of-type`, function (event)
    {
        // Re-checked synchronously here because "selectionchange" is queued as a task: on a
        // quick CTRL + drag the latch may not have been set yet when the click lands.
        updateQuickFilterCancelled();
        if (!skyward.keys.globalCtrlPressed || quickFilterCancelled)
        {
            return;
        }

        // Clicks on links and on editable cell controls keep their default behavior -- navigating,
        // and placing the caret so the cell can be typed into or pasted over.
        if (isInteractiveTarget(event.target))
        {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        const clickedElement = $(event.target);
        const dataCell = clickedElement.closest(`.${classNames.browseDataCell}`);
        const columnIndex = dataCell.data("column");
        const headerCell = browseData.header?.find(`.${classNames.unlockedHeaderTableRow} td[data-field-index="${columnIndex}"]`) ?? $();

        if (headerCell.length === 0 || dataCell.hasClass("sortDisabled"))
        {
            return;
        }

        const fieldName = headerCell.data("field-name");
        if (!fieldName)
        {
            return;
        }

        // Not every column renderer sets a field value on the cell. Filtering without one sends an
        // empty value, which the browse comes back filtered on [Blank] rather than what was clicked,
        // so leave the browse alone instead. Checked with attr() rather than data() to tell a cell
        // that has no value from one whose value is legitimately blank. (PR 6717946)
        if (dataCell.attr("data-field-value") === undefined)
        {
            return;
        }

        const checkbox = clickedElement.is(".checkbox") ? clickedElement : clickedElement.find(".checkbox").first();
        const isBoolean = checkbox.length > 0;
        const rawValue = String(dataCell.data("field-value") ?? "");
        const displayValue = clickedElement.text();
        const columnSelector = `.column${columnIndex}`;
        const columnCells = (browseData.unlockedBody?.find(columnSelector) ?? $())
            .add(browseData.lockedBody?.find(columnSelector) ?? $());
        const matchingColCells = columnCells.filter(`[data-field-value="${rawValue}"]`);
        
        if (dataCell.hasClass(classNames.isSelectionFiltered))
        {
            matchingColCells.removeClass(classNames.isSelectionFiltered);
            removeFilterValue(fieldName, rawValue, isBoolean);
        }
        else
        {
            if (isBoolean)
            {
                columnCells.removeClass(classNames.isSelectionFiltered);
            }
            matchingColCells.addClass(classNames.isSelectionFiltered);
            addFilterValue(fieldName, rawValue, displayValue, isBoolean);
        }
    });

    // Adds a value to the pending filter. Boolean columns filter on a single true/false value,
    // other columns accumulate a raw value -> display value map.
    function addFilterValue(fieldName: string, rawValue:string, displayValue: string, isBoolean: boolean)
    {
        if (!filterJson.hasOwnProperty(fieldName))
        {
            filterJson[fieldName] = { "FilterType": "selection" };
        }

        if (isBoolean)
        {
            filterJson[fieldName][trueOnly] = rawValue?.toLowerCase();
        }
        else
        {
            let selectedValues = {} as Record<string, string>;
            if (filterJson[fieldName].hasOwnProperty(dmsJson))
            {
                selectedValues = JSON.parse(filterJson[fieldName][dmsJson]);
            }
            selectedValues[rawValue] = displayValue;

            filterJson[fieldName][dmsJson] = JSON.stringify(selectedValues);
        }
    }

    // Removes a previously selected value from the pending filter.
    function removeFilterValue(fieldName: string, rawValue: string, isBoolean: boolean)
    {
        if (!filterJson.hasOwnProperty(fieldName))
        {
            return;
        }

        if (isBoolean)
        {
            delete filterJson[fieldName][trueOnly];
            filterJson[fieldName][dmsJson] = "{}";
            return;
        }

        if (!filterJson[fieldName].hasOwnProperty(dmsJson))
        {
            return;
        }

        const selectedValues = JSON.parse(filterJson[fieldName][dmsJson]) as Record<string, string>;
        delete selectedValues[rawValue === "" ? "[No Data]" : rawValue];
        filterJson[fieldName][dmsJson] = JSON.stringify(selectedValues);
    }

    // Starts a quick filter session for one CTRL hold, remembering what to roll back to.
    function beginQuickFilterSession()
    {
        cachedFilterState = JSON.stringify(filterJson);
        cachedHighlights = browseData.body?.find(`.${classNames.isSelectionFiltered}`);
        quickFilterCancelled = false;
        updateQuickFilterCancelled();
    }

    // Aborts quick filter the moment text is selected: cells picked during this hold are
    // un-picked, the pending filter is rolled back so releasing CTRL requests nothing, and the
    // affordances stay down until CTRL is released and pressed again.
    function updateQuickFilterCancelled()
    {
        if (!quickFilterCancelled && skyward.keys.globalCtrlPressed && hasTextSelectionInBrowse())
        {
            quickFilterCancelled = true;
            filterJson = JSON.parse(cachedFilterState ?? "{}");
            browseData.body?.find(`.${classNames.isSelectionFiltered}`).removeClass(classNames.isSelectionFiltered);
            cachedHighlights?.addClass(classNames.isSelectionFiltered);
        }

        browseData.browse?.toggleClass(classNames.quickFilterActive, !quickFilterCancelled);
    }

    function cleanupSelectionChangeHandler()
    {
        $(document).off(selectionChangeEvent, updateQuickFilterCancelled);
    }

    // True when the user has text selected inside this browse. Used to tell "about to copy"
    // apart from "about to filter", since both start by holding CTRL.
    function hasTextSelectionInBrowse(): boolean
    {
        const selection = document.getSelection();
        if (selection === null || selection.isCollapsed || selection.rangeCount === 0)
        {
            return false;
        }

        const browseElement = browseData.browse?.get(0);
        return browseElement != null && browseElement.contains(selection.getRangeAt(0).commonAncestorContainer);
    }

    // Links and editable controls handle their own clicks; quick filter must not swallow them.
    function isInteractiveTarget(target: EventTarget | null): boolean
    {
        return $(target as Element).closest("a, input, textarea, select, [contenteditable]").length > 0;
    }

    // True when the element has enough overflow to actually scroll. A locked browse body always
    // reserves a scrollbar, so the overflow has to be measured rather than inferred from one. The
    // one pixel of tolerance keeps sub-pixel rounding from reporting an element that cannot move.
    function canScrollVertically(element: HTMLElement): boolean
    {
        return element.scrollHeight - element.clientHeight > 1;
    }

    // True when the wheel is over the cells themselves. The browse body fills its panel, so a browse
    // whose columns do not reach the full width leaves empty space to the right of them. Nothing
    // there can be quick filtered, so the wheel is not worth taking.
    function isOverBrowseCell(target: EventTarget | null): boolean
    {
        return $(target as Element).closest(`.${classNames.browseDataCell}`).length > 0;
    }
}

function addColumnHeaderResizeHandler(browseData: Browse)
{
    if (mobileAccess || !browseData.header?.length)
    {
        return;
    }

    const iconContainerDivs = browseData.header.find(`.${classNames.iconContainerDiv}`);
    if (!iconContainerDivs.length)
    {
        return;
    }

    const resizeObserver = new ResizeObserver((entries) =>
    {
        for (const entry of entries)
        {
            const iconContainer = $(entry.target);
            const parent = iconContainer.closest(`.${classNames.browseHeaderColumn}`);
            if (!parent.length)
            {
                continue;
            }

            const iconSpansToHideInOrder =
            [
                iconContainer.find(`.${classNames.browseColumnIconSpan}.${classNames.browseColumnSortSpan} .sortNumberLabel`),
                iconContainer.find(`.${classNames.browseColumnIconSpan}.${classNames.browseColumnSuperUser}`),
                iconContainer.find(`.${classNames.browseColumnIconSpan}.${classNames.browseColumnSortSpan}`),
                iconContainer.find(`.${classNames.browseColumnIconSpan}.browseColumnFiltered`)
            ];

            const browseColumnFilterMenuLaunch = iconContainer.find(`.${classNames.browseColumnFilterMenuLaunch}`).first();
            const isOverflowing = () =>
            {
                if (!browseColumnFilterMenuLaunch.length)
                {
                    return false;
                }

                const filterMenuLaunchRight = browseColumnFilterMenuLaunch[0].getBoundingClientRect().right;
                const parentRight = parent[0].getBoundingClientRect().right;
                return filterMenuLaunchRight > parentRight;
            };

            if (isOverflowing())
            {
                for (const iconSpan of iconSpansToHideInOrder)
                {
                    if (!iconSpan.length || !iconSpan.is(":visible"))
                    {
                        continue;
                    }

                    iconSpan.css("display", "none");

                    if (!isOverflowing())
                    {
                        break;
                    }
                }
            }
            else
            {
                for (const iconSpan of [...iconSpansToHideInOrder].reverse())
                {
                    if (!iconSpan.length || iconSpan.is(":visible"))
                    {
                        continue;
                    }

                    iconSpan.css("display", "");

                    if (isOverflowing())
                    {
                        iconSpan.css("display", "none");
                        break;
                    }
                }
            }
        }
    });

    iconContainerDivs.each(function ()
    {
        resizeObserver.observe(this);
    });
}

function addColumnHeaderClickEvents(browseData: Browse)
{
    if (mobileAccess || !browseData.header?.length)
    {
        return;
    }

    browseData.header.on("click", `.${classNames.browseColumnSuperUser}`, browseColumnSuperUserClick);
    browseData.header.on("click", `.${classNames.browseColumnFilterMenuLaunch}`, browseHeaderColumnClick);
    browseData.header.on("click", `.${classNames.browseColumnHeaderSort}`, changeSort);

    if (browseData.renderSortableHeader !== false)
    {
        browseData.header.on("click", `.${classNames.browseColumnSortSpan}`, changeSort);
    }
}

function addPagingButtonClickEvents(browseName: string)
{
    const footers = $(`#${browseName}_footer`);
    footers.on("click", `.${classNames.pagingButton}:not(.${classNames.pagingButtonDisabled})`, function (this: HTMLElement)
    {
        changePage(this, browseName, $(this).data());
    });
}

function totalRecordsButtonClicked(this: HTMLElement | JQuery)
{
    const totalRecordsButton = $(this);

    if (totalRecordsButton.hasClass(classNames.totalRecordsButtonDisabled))
    {
        return;
    }

    const browse = getBrowseById(totalRecordsButton.parents(`.${classNames.browse}`)[0].id);
    if (!browse)
    {
        return;
    }

    const menuItems: MenuItemDefinition[] = [
        { type: "title", text: "Total Records" },
        { type: "custom", content: recordCount }
    ];

    totalRecordsButton.addClass(classNames.totalRecordsButtonDisabled);
    showMenu(menuItems, totalRecordsButton,
    {
        beforeClose: function ()
        {
            totalRecordsButton.trigger("focus");
            totalRecordsButton.removeClass(classNames.totalRecordsButtonDisabled);
        }
    });

    function recordCount()
    {
        const content = $(`<div class='customMenuPopupItem totalRecordsCount' aria-live='polite'>${getImageHtml("getRecordCountPageLoadingGif")}Loading Total Records</div>`);
        const data = getRequiredBrowseData(browse!, totalRecordsButton.closest(`.${classNames.browse}`).data());

        getBrowseRowCount(browse!, data).then(function (recordCount)
        {
            content.html(`${recordCount} ${"Total Record".pluralize("Total Records", recordCount)}`);
        });

        return content;
    };
}

function addTotalRecordsClickEvents(browseName: string)
{
    const footers = $(`#${browseName}_footer`);
    footers.on("click", `.${classNames.totalRecordsButton}`, totalRecordsButtonClicked);
}

function addColumnHeaderResizeEvents(browse: JQuery, browseName: string)
{
    if (mobileAccess)
    {
        return;
    }
    const browseId = browse.attr("id")!;

    // Used to batch up resizable columns
    const resizeDivs: { element: JQuery, resizable: JQueryUI.ResizableOptions }[] = [];

    browse.find(`.${classNames.tdResizeDiv}`).each(function ()
    {
        const element = $(this);
        const data = element.data() as ResizeBrowseColumnData;
        const columnIndex = data.column!;
        const updateBrowseView = !!data.updateBrowseView;

        const resizable: JQueryUI.ResizableOptions =
        {
            minWidth: minColumnWidth,
            maxWidth: maxColumnWidth,
            handles: "e"
        };

        if (element.hasClass(classNames.locked))
        {
            resizable.resize = function (_event, ui: JQueryUIResizable)
            {
                const unlockedElement = browse.find(`#${browseName}_unlockedHeaderColumn_${columnIndex}`);
                unlockedElement.css("width", ui.size.width);
            };

            resizable.stop = function (_event, ui: JQueryUIResizable)
            {
                applyResize(updateBrowseView, columnIndex, ui.size.width, true);
            };
        }
        else
        {
            resizable.stop = function (_event, ui: JQueryUIResizable)
            {
                applyResize(updateBrowseView, columnIndex, ui.size.width, false);
            };
        }
        resizeDivs.push({
            element: element,
            resizable: resizable
        });
    });

    for (const item of resizeDivs)
    {
        item.element.resizable(item.resizable);
    }

    async function applyResize(updateBrowseView: boolean, headerIndex: number | null, columnWidth: number, isLockedColumn: boolean)
    {
        const browse = getBrowseById(browseName);
        if (!browse)
        {
            return;
        }
        if (headerIndex !== null)
        {
            const resizeChildren = `#${browseName} .${classNames.browseDataCell}.column${headerIndex}`;
            $(resizeChildren).each(function ()
            {
                const dataCell = $(this);
                const columnIndex = dataCell.attr("data-column");
                if (columnIndex && columnIndex === headerIndex.toString())
                {
                    dataCell.children().css("width", columnWidth);
                }
            });

            if (browse.totals?.container.length)
            {
                const totalColumns = browse.totals.container.find(`.${classNames.browseBodyTotalColumn}`);
                const updatedElement = totalColumns.filter(`[data-column='${headerIndex}']`);
                if (isLockedColumn)
                {
                    const initialLeft = parseFloat(updatedElement[0].style.left) + columnWidth;
                    const followingElements = totalColumns.slice(totalColumns.index(updatedElement) + 1);
                    updateTotalColumnOffsets(followingElements, initialLeft);
                }
                updatedElement.css("width", columnWidth);
            }
        }

        if (isLockedColumn)
        {
            resizeDataLockedBody();
        }

        browseResize(browseId);

        const currentBrowse = getBrowseById(browseId);

        if (updateBrowseView && currentBrowse)
        {
            const data: ColumnResizeSaveData =
            {
                columnIndex: headerIndex!,
                columnWidth: columnWidth,
                fieldName: currentBrowse.browse?.find(`[data-column-index=${headerIndex}]`).data("fieldName") as string
            };

            let url: string;

            if (currentBrowse.data?.browseViewEditorHash)
            {
                url = `${virtualDir}SkySys/BrowseView/ResizeBrowseViewEditorColumn`;
                data.postData = JSON.stringify(currentBrowse.data);
            }
            else
            {
                url = `${virtualDir}SkySys/BrowseView/ResizeColumn`;
                data.pageModule = currentBrowse.pageModule;
                data.pageObject = currentBrowse.pageObject;
                data.pageScreen = currentBrowse.pageScreen;
                data.pageTab = currentBrowse.pageTab;
                data.browseName = currentBrowse.browseName.replace("detailsPanel_", "");
                data.taskName = currentBrowse.taskName;
                data.browseId = currentBrowse.browseId;
            }

            const response = await $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "JSON",
                data: data,
                activityIndicator: { hideGlass: true }
            }) as ResizeBrowseColumnResponse;

            if (response.success && response.browseViewID && response.browseViewName)
            {
                currentBrowse.viewId = response.browseViewID;
                const viewButton = $(`#${browseId}_viewButton`);
                const valueLabel = viewButton.find(`.${classNames.buttonSelectedValueLabel}`);
                const parenthesis = valueLabel.find(`.${classNames.buttonParenthesisLabel}`);

                // If the view was previously not modified, but is now
                if (response.isModifiedBrowseView && parenthesis.length === 0)
                {
                    const modifiedSvg = getSvg("ViewModified", "BrowseLevel");
                    const currentSvg = viewButton.find("svg");
                    currentSvg.replaceWith(modifiedSvg);

                    valueLabel
                        .empty()
                        .text(`${response.browseViewName} (`)
                        .append($("<span>", { class: classNames.buttonParenthesisLabel, text: "Modified" }))
                        .append(")");
                }
                // If the view used to be modified, but isn't anymore
                else if (!response.isModifiedBrowseView && parenthesis.length > 0)
                {
                    valueLabel.empty().text(response.browseViewName);
                }
            }
        }
    }

    function resizeDataLockedBody()
    {
        const shadowWidth = 13;
        let total = shadowWidth;
        $(`#${browseName} .${classNames.lockedBrowseBody} tr:first-child td`).each(function ()
        {
            total += $(this).width()!;
        });
        const lockedBrowseBody = $(`#${browseName} .${classNames.lockedBrowseBody}`);
        const scrollWrapper = lockedBrowseBody.parent();
        const scrollbarWidth = lockedBrowseBody.width()! - scrollWrapper.width()!;
        lockedBrowseBody.css("width", total + scrollbarWidth);
        scrollWrapper.css("width", total);
    }
}

function selectRecord(browseId: string, id: string | number)
{
    const browse = getBrowseById(browseId);
    if (browse !== undefined)
    {
        eventCallbacksInternal.recordSelectionMade.dispatchCallbacks({ browseId: browseId, selectedId: id });
    }

    closePopup(undefined, CloseReasons.SelectedItem);
}

function finishRegistration(browseName: string)
{
    const browse = getBrowseById(browseName);
    if (!browse)
    {
        return;
    }

    const debounceResize = debounce(function ()
    {
        browseResize(browseName);
    }, 50);

    $(window).trigger("resize"); // Triggers modallayer.positionEELContents()
    debounceResize();

    // must be after resize() so our detailsPanel.eventCallbacks.resizeCanOpen callback doesn't run and open the details panel twice
    browse.isRegistered = true;

    if (browse.totals?.container.length)
    {
        displayBrowseTotals(browse);
    }

    if (browse.currentRow !== null && browse.currentRow !== undefined)
    {
        setCurrentRecord(browseName, browse.currentRow);
    }
    else if (browse.relatedBrowse)
    {
        const relatedBrowse = getBrowseById(browse.relatedBrowse);
        if (relatedBrowse?.body)
        {
            relatedBrowse.body.empty();
        }
    }

    // This is undocumented by jquery: it will only trigger event listeners that match the event type and at least one of the namespaces (here just browseName)
    browse.browse?.trigger(`browseLoaded.${browseName}`, browse);

    if (browse.isInDetailsPanel || browse.detailsPanelType === browseDetailsPanel.detailsPanelTypes.row && !(browse.rowModule && browse.rowObject && browse.rowScreen))
    {
        $(`#${browseName}_previewDetails`).remove();
    }
    else
    {
        browseDetailsPanel.tryRefreshDetailsPanel(browseName);
    }
}

function getCurrentBrowse()
{
    const browseName = getCurrentBrowseName();
    return getBrowseById(browseName);
}

function getLockedRowElement(browse: Browse, rowOverride?: number)
{
    return getCurrentRowElement("locked", browse.id, (rowOverride ?? browse.currentRow)!, browse.browseType);
}

function getUnlockedRowElement(browse: Browse, rowOverride?: number)
{
    return getCurrentRowElement("unlocked", browse.id, (rowOverride ?? browse.currentRow)!, browse.browseType);
}

function getRowElements(browse: Browse, rowOverride?: number)
{
    return getLockedRowElement(browse, rowOverride).add(getUnlockedRowElement(browse, rowOverride));
}

function keyDown(event: JQuery.KeyDownEvent)
{
    const browse = getCurrentBrowse();

    if (!browse?.keyEventsEnabled || shouldIgnoreKeyboardEvent(document.activeElement))
    {
        return;
    }

    const eventKeys = skyward.keys.getKeyNamesFromEvent(event);
    let selectPreviousRow = eventKeys.ARROW_UP;
    let selectNextRow = eventKeys.ARROW_DOWN;

    if (browse.selectMode && (selectPreviousRow || selectNextRow))
    {
        const layer = getLayerFromElement(browse.browse!);
        if (layer)
        {
            $(layer.originalActiveElement).trigger("focus");
        }
    }

    if (browse.browseType === "Tile")
    {
        selectPreviousRow = selectPreviousRow || eventKeys.ARROW_LEFT;
        selectNextRow = selectNextRow || eventKeys.ARROW_RIGHT;
    }

    if (selectPreviousRow || selectNextRow)
    {
        let newRowNumber: number | undefined;

        if (selectNextRow)
        {
            if (browse.currentRow === null || browse.currentRow === undefined)
            {
                event.preventDefault();
                return;
            }

            if (browse.currentRow < browse.recordCount! - 1)
            {
                newRowNumber = browse.currentRow + 1;
            }
            else if (browse.browseType === "DistinctMultiSelect" && browse.currentRow === browse.recordCount! - 1)
            {
                newRowNumber = -1;
            }
            else
            {
                newRowNumber = 0;
            }
        }
        else if (selectPreviousRow)
        {
            if (browse.currentRow === null || browse.currentRow === undefined)
            {
                event.preventDefault();
                return;
            }

            if (browse.currentRow > 0)
            {
                newRowNumber = browse.currentRow - 1;
            }
            else if (browse.browseType === "DistinctMultiSelect" && browse.currentRow === 0)
            {
                newRowNumber = -1;
            }
            else
            {
                newRowNumber = browse.recordCount! - 1;
            }
        }

        if (newRowNumber !== undefined && browse.currentRow !== newRowNumber)
        {
            changeRow(browse.id, browse, newRowNumber);
        }

        keyUpHandler.addKeyUpHandler(event.which, browse.id);

        event.preventDefault();
        event.stopPropagation();
        return;
    }
    else if (eventKeys.ENTER)
    {
        if (browse.browseType !== "DistinctMultiSelect")
        {
            // ToDo: this function's current state is causing undesired key behavior, which has to be overridden with the below 'if' check on a browseExpandCollapseButton.
            // Otherwise an enter on this button will instead select the browse's first row's primary button
            const activeElement = $(document.activeElement!);
            if (activeElement.hasClass(classNames.browseExpandCollapseButton))
            {
                return;
            }
            else if (activeElement.length > 0 && (["A", "BUTTON"].includes(activeElement[0].nodeName) || activeElement.attr("role") === "button"))
            {
                activeElement.trigger("click");
            }
            else
            {
                if (browse.selectMode)
                {
                    if (browse.body && $(browse.body).find(`.${classNames.current}`).first().length > 0)
                    {
                        selectRecord(browse.id, browse.primaryKeys![browse.currentRow!]);
                    }
                }
                else
                {
                    const currentRow = getUnlockedRowElement(browse);
                    const targetId = currentRow.data("targetid") as number;
                    if (browse.primaryKeys![browse.currentRow!] !== targetId)
                    {
                        let defaultRowMenuButton;
                        if (browse.browseType === "Tile")
                        {
                            defaultRowMenuButton = currentRow;
                        }
                        else
                        {
                            defaultRowMenuButton = currentRow.find(`td.${classNames.browseRowOptions} div a.${classNames.button}`).first();
                        }
                        if (defaultRowMenuButton.length > 0)
                        { // Simulate click on Default RowAction.  Not all point to a details screen, or the same Module/Object of the Browse.  Accounts for "Select" of EEL's, if/when
                            defaultRowMenuButton[0].click();
                        }
                    }
                }
            }
        }

        event.preventDefault();
        event.stopPropagation();
    }
}

function rowChange(browseName: string, row: number, loadRelatedBrowses: boolean)
{
    browseDetailsPanel.tryRowChange(browseName, doRowChange, true);

    function doRowChange()
    {
        setCurrentRecord(browseName, row,
            {
                setCurrentBrowseName: true,
                loadRelatedBrowses: loadRelatedBrowses
            });
    }
}

function repositionMoreMenu()
{
    const browsesOnScreen = Object.keys(allBrowseStats);
    for (const browseOnScreen of browsesOnScreen)
    {
        const moreButton = $(`#${browseOnScreen}_moreButton`);
        const popupMenu = $(`#${browseOnScreen}MenuPopup`);
        const offset = moreButton.offset();
        if (offset)
        {
            offset.top += moreButton.outerHeight()!;
            offset.left = offset.left + moreButton.outerWidth(true)! - popupMenu.outerWidth(true)! - 2; //the 2 pixel difference is to account for padding on browses not covered in outerWidth

            popupMenu.offset({
                left: offset.left,
                top: offset.top
            });
        }
    }
}

function init(selector: string)
{
    const selectorElement = $(selector);
    const browseElem = selectorElement.find(`.${classNames.browse}`).add(selectorElement.filter(`.${classNames.browse}`));
    if (browseElem.length)
    {
        // On DOM load, bind simulated-focus-handler to any newly loaded browses
        bindLockedBodySimulatedFocus(browseElem);

        browseElem.each(function ()
        {
            const browse = getBrowseById(this.id);
            if (!browse)
            {
                return;
            }

            if (browse.isRegistered === false)
            {
                finishRegistration(this.id);
            }
        });
    }

    // Customization
    selectorElement.find(`.${classNames.customBrowse}`).each(function initializeCustomBrowse()
    {
        const browse = $(this);
        const browseName = browse.data("browseName") as string;
        const defaults =
        {
            browseType: "default",
            id: browseName,
            refreshTimeout: -1,
            keyEventsEnabled: true,
            dynamicFilterHashes: {} as Record<string, unknown>,
            dynamicFilterValues: {} as Record<string, unknown>
        };

        if (browse.data("isSimpleBrowse"))
        {
            // based on SimpleBrowse.cs
            $.extend(defaults,
            {
                preventColumnSort: true,
                preventColumnResize: true,
                hidePreviewDetailsButton: true,
                hideBrowseControl: true,
                renderSearchBox: false,
                renderViewButton: false,
                renderFilterButton: false,
                renderHeaderSettings: false,
                renderSortableHeader: false,
                renderRowsPerPageOption: false
            });
        }

        const newBrowse = Object.assign({}, defaults, browse.data(), { isSimpleBrowse: undefined }) as unknown as Browse;
        addBrowse(newBrowse, browseName);
        prependOpenBrowse(browseName);
        get(browseName, {});
    });
}

function popInsertColumnView(browse: Browse, sortFieldIndex: number, element: JQuery<HTMLElement>)
{
    const options =
    {
        anchorTo: element,
        beforeClose: function ()
        {
            removeBrowseResizeCallback(dialog.close);
        }
    };
    const dialog = showDialog("Insert Column", buildInsertColumnPopup(browse), [DEFAULT_CLOSE_BUTTON], options);

    dialog.content.on("treeBrowseLevelChanged", dialog.animateModalContents);
    dialog.content.on("treeBrowseSave", async function (_e, treeBrowseData: TreeBrowseData)
    {
        if (!treeBrowseHasSelectedField(treeBrowseData))
        {
            return;
        }

        dialog.content.off("treeBrowseSave");

        const isLockedColumn = element.closest(`#${browse.browseName}_lockedHeader`).length > 0;
        const listData = getSelectedFieldData(dialog.content);

        await insertColumn(browse, sortFieldIndex, isLockedColumn, listData);

        dialog.close();
    });
}

async function deleteColumn(browse: Browse, fieldName: string, sortFieldIndex: number)
{
    const data: DeleteColumnSaveData =
    {
        columnIndex: sortFieldIndex,
        fieldName: fieldName
    };

    let url: string;

    if (browse.data?.browseViewEditorHash)
    {
        url = `${virtualDir}SkySys/BrowseViewEditor/DeleteColumnFromBrowseViewEditor`;
        data.postData = JSON.stringify(browse.data);
    }
    else
    {
        url = `${virtualDir}SkySys/BrowseView/DeleteColumn`;
        data.pageModule = browse.pageModule;
        data.pageObject = browse.pageObject;
        data.pageScreen = browse.pageScreen;
        data.browseName = browse.browseName.replace("detailsPanel_", "");
        data.taskName = browse.taskName;
    }

    const responseData = await $.ajax(
    {
        url: url,
        type: "POST",
        dataType: "JSON",
        data,
    }) as SuccessResponse | undefined;

    if (responseData?.success)
    {
        const seekId = browse.primaryKeys![browse.currentRow!];
        get(browse.id, { seekId: seekId });
    }
    else
    {
        showErrorDialog("An error occurred while deleting the column.", `There was an error when attempting to delete the "${fieldName}" column.`);
    }
}

function buildInsertColumnPopup(browse: Browse)
{
    const data: InsertColumnPopupSaveData =
    {
        browseName: browse.browseName
    };

    let url;

    if (browse.data?.browseViewEditorHash)
    {
        url = `${virtualDir}SkySys/BrowseViewEditor/BuildTreeBrowse/`;
        data.postData = JSON.stringify(browse.data);
    }
    else
    {
        url = `${virtualDir}SkySys/BrowseView/BuildTreeBrowse/`;
        data.lookupModule = browse.dataModule;
        data.lookupObject = browse.dataObject;
        data.browseId = browse.browseId;
    }

    return $.ajax(
    {
        url: url,
        type: "POST",
        dataType: "viewparthtml",
        data: data
    });
}

async function insertColumn(browse: Browse, sortFieldIndex: number, isLockedColumn: boolean, listData?: FormattedFieldProps)
{
    if (listData?.fieldName === undefined)
    {
        return;
    }

    const dotIndex = listData.fieldName.indexOf(".");
    let fieldName: string;
    if (dotIndex > 0)
    {
        //The way the data.fieldName is structured is :
        //'[SelectedDataObject].[FieldName] and we dont want grab [SelectedDataObject].[FieldName] off of [SelectedDataObject]. We just want the fieldname
        fieldName = listData.fieldName.substring(dotIndex + 1, listData.fieldName.length);
    }
    else
    {
        fieldName = listData.fieldName;
    }

    const data: InsertColumnSaveData =
    {
        columnIndexToInsertAfter: sortFieldIndex,
        fieldIsDynamic: listData.isDynamicColumn,
        columnFieldName: fieldName,
        isLockedColumn: isLockedColumn
    };

    let url: string;

    if (browse.data?.browseViewEditorHash)
    {
        url = `${virtualDir}SkySys/BrowseViewEditor/InsertColumnFromBrowseViewEditor`;
        data.postData = JSON.stringify(browse.data);
    }
    else
    {
        url = `${virtualDir}SkySys/BrowseView/InsertColumn`;
        data.pageModule = browse.pageModule;
        data.pageObject = browse.pageObject;
        data.pageScreen = browse.pageScreen;
        data.browseName = browse.browseName.replace("detailsPanel_", "");
        data.taskName = browse.taskName;
        data.browseId = browse.browseId;
    }

    const response = await $.ajax(
    {
        url: url,
        type: "POST",
        dataType: "JSON",
        data: data,
    }) as SuccessResponse | undefined;

    if (response?.success)
    {
        const seekId = browse.primaryKeys![browse.currentRow!];
        get(browse.id, { seekId: seekId });
    }
    else
    {
        showErrorDialog("An error occurred while inserting the column.", `There was an error when attempting to insert the "${fieldName}" column.`);
    }
}

function treeBrowseHasSelectedField(treeBrowseData: TreeBrowseData)
{
    const data = treeBrowseData.getSelectedFieldData();
    if (data === undefined)
    {
        return;
    }

    return !!data.fieldName;
}

function initialize()
{
    registerLoadDOMCallback(init);
    registerLoadDOMCallback(initActiveBrowseClass);
    registerBrowseResizeCallback(resizeBrowseList);
    registerLayoutResizeCallback(repositionMoreMenu);

    if (!mobileAccess)
    {
        registerLoadDOMCallback(initSortableColumns);
    }

    // Event handlers
    const events =
    {
        getBrowseExport: exportBrowse,
        showAuditLegend: showAuditLegend,
        browseLinkColumnPopup: browseLinkColumnPopup,
        forceToggleDetailsPanel: function ()
        {
            const button = $(this);
            const browseId = button.attr("data-browse-id")!;
            browseDetailsPanel.toggleDetailsPanel(browseId, true);
        }
    };

    registerEvents("browse", events);

    registerErrorDataGatherer("browse", gatherDataForError);

    registerLoadDOMCallback(() => { browseDetailsPanel.init(); });

    $(document.documentElement).on("keydown", keyDown);
}

initialize();
